(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8797],{

/***/ 43927:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "m19 9 1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25L19 9zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25L19 15z"
}), 'AutoAwesome');
exports.Z = _default;

/***/ }),

/***/ 94184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 7084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _showUrl_; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/Footer/Footer.tsx
var Footer = __webpack_require__(91001);
// EXTERNAL MODULE: ./src/services/ShowService.tsx
var ShowService = __webpack_require__(90774);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@mui/styled-engine/StyledEngineProvider/StyledEngineProvider.js
var StyledEngineProvider = __webpack_require__(94810);
// EXTERNAL MODULE: ./src/components/index.ts + 109 modules
var components = __webpack_require__(1356);
// EXTERNAL MODULE: ./src/services/BookingInterestService.tsx + 1 modules
var BookingInterestService = __webpack_require__(5668);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/pages/Audience/BookingManager/Steps/Terms/TermsStep.styles.ts


var TermsContainer = (0,styled/* default */.ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._500,
    maxWidth: theme.space._1250,
    alignSelf: "strech",
    "@media (max-width: 600px)": {
      maxWidth: "unset"
    }
  };
});
var StyledLink = (0,styled/* default */.ZP)((link_default()))(function (_ref2) {
  var theme = _ref2.theme;
  return {
    color: theme.colors["blue.400"],
    textDecoration: "none"
  };
});
// EXTERNAL MODULE: ./src/components/Page/Page.tsx
var Page = __webpack_require__(96204);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./src/icons/index.ts
var icons = __webpack_require__(46409);
;// CONCATENATED MODULE: ./src/pages/Audience/BookingManager/BookingManager.styles.ts




var BookingDetailsContainer = (0,styled/* default */.ZP)(Page/* default */.Z)(function (_ref) {
  var theme = _ref.theme;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._600
  };
});
var FormPage = (0,styled/* default */.ZP)(Page/* default */.Z)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    position: 'relative',
    marginTop: theme.space._1000,
    width: "100%",
    maxWidth: "1440px",
    marginLeft: "auto",
    marginRight: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: theme.space._700,
    "@media (max-width: 900px)": {
      alignItems: "center",
      flexDirection: "column"
    }
  };
});
var CTAButtonContainer = (0,styled/* default */.ZP)("div")(function (_ref3) {
  var theme = _ref3.theme;
  return {
    display: "flex",
    paddingTop: theme.space._200,
    justifyContent: "space-between",
    alignItems: "center",
    alignSelf: "stretch"
  };
});
var ButtonContainer = (0,styled/* default */.ZP)("div")(function (_ref4) {
  var theme = _ref4.theme;
  return {
    display: "flex",
    paddingTop: theme.space._100,
    justifyContent: "center",
    alignItems: "center"
  };
});
var ButtonLabel = (0,styled/* default */.ZP)(Typography/* default */.Z)(function (_ref5) {
  var theme = _ref5.theme;
  return {
    color: theme.colors["neutral.50"],
    fontFamily: theme.fonts["default"],
    fontSize: theme.fontSizes.md,
    fontStyle: 'normal',
    fontWeight: theme.fontWeights.semibold,
    lineHeight: theme.lineHeights["short"]
  };
});
var ButtonIcon = (0,styled/* default */.ZP)(icons/* Icon */.J)(function (_ref6) {
  var theme = _ref6.theme;
  return {
    width: theme.space._450,
    height: theme.space._450
  };
});
// EXTERNAL MODULE: ./src/contexts/ModalContext.tsx
var ModalContext = __webpack_require__(19780);
;// CONCATENATED MODULE: ./src/pages/Audience/BookingManager/Steps/Tickets/TicketsStep.styles.ts

var TicketContainer = (0,styled/* default */.ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._600,
    width: "min-content",
    alignSelf: "strech",
    "@media (max-width: 900px)": {
      width: "100%"
    }
  };
});
var StyledForm = (0,styled/* default */.ZP)("form")(function (_ref2) {
  var theme = _ref2.theme;
  return {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: theme.space._600
  };
});
var StyledBlueSpan = (0,styled/* default */.ZP)("span")(function (_ref3) {
  var theme = _ref3.theme;
  return {
    color: theme.colors["blue.400"]
  };
});
// EXTERNAL MODULE: ./src/utils/string-utils.tsx
var string_utils = __webpack_require__(46955);
// EXTERNAL MODULE: ./src/utils/constants.tsx
var constants = __webpack_require__(39509);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/pages/Audience/BookingManager/Steps/Terms/TermsStep.tsx













var TermsStep = function TermsStep(_ref) {
  var router = _ref.router,
      onNextButtonClick = _ref.onNextButtonClick,
      onPrevButtonClick = _ref.onPrevButtonClick,
      show = _ref.show,
      session = _ref.session,
      submitting = _ref.submitting,
      _ref$errorMessage = _ref.errorMessage,
      errorMessage = _ref$errorMessage === void 0 ? "" : _ref$errorMessage,
      _ref$bookingInterestE = _ref.bookingInterestError,
      bookingInterestError = _ref$bookingInterestE === void 0 ? false : _ref$bookingInterestE;

  var _useState = (0,react.useState)(false),
      isSessionAgreed = _useState[0],
      setIsSessionAgreed = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isTTTAgreed = _useState2[0],
      setIsTTTAgreed = _useState2[1];

  var _useModal = (0,ModalContext/* useModal */.dd)(),
      openModal = _useModal.openModal,
      closeModal = _useModal.closeModal,
      modalState = _useModal.modalState;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TermsContainer, {
    "data-cy": "termsContainer",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* TitleSubtitle */.V9, {
      title: "Accept Terms & Apply!",
      subTitle: "So you can be part of the audience at a live TV recording, please read and accept the following terms and conditions:"
    }), (show === null || show === void 0 ? void 0 : show.hasTermsAndConditions) && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Checkbox */.XZ, {
      "data-cy": "tc-checkbox-1",
      checked: isSessionAgreed,
      onChange: setIsSessionAgreed,
      label: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: ["I agree to the", " ", /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
          "data-cy": "session-terms-link",
          target: "_blank",
          href: "/api/backend/termsandconditions?showId=".concat(show === null || show === void 0 ? void 0 : show.id),
          children: (0,string_utils/* formatString */.Uw)(constants/* tncTemplate */.u5, show === null || show === void 0 ? void 0 : show.name)
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Checkbox */.XZ, {
      "data-cy": "tc-checkbox-2",
      checked: isTTTAgreed,
      onChange: setIsTTTAgreed,
      label: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: ["I understand that having tickets  ", /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Tooltip */.u, {
          tooltipName: "showMustGoOn",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledBlueSpan, {
            children: " does not guarantee "
          })
        }), " me entry to the show"]
      })
    }), bookingInterestError && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* InfoMessage */.$J, {
      message: errorMessage,
      hasBackground: true,
      variant: "error"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CTAButtonContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
        size: "md",
        variant: "tertiary",
        onClick: function onClick() {
          return onPrevButtonClick();
        },
        sx: {
          padding: 0
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ButtonContainer, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ButtonIcon, {
            icon: "ArrowLeft"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonLabel, {
            children: "Back"
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
        size: "md",
        gradientStyle: "gradient3",
        onClick: function onClick() {
          return openModal(ModalContext/* Modals.TermsHighlight */.nK.TermsHighlight, function () {
            closeModal();
            onNextButtonClick();
          });
        },
        disabled: (show === null || show === void 0 ? void 0 : show.hasTermsAndConditions) && !isSessionAgreed || !isTTTAgreed,
        "data-cy": "submit-interest-button",
        loading: submitting,
        children: "Continue"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Modal */.u_, {})]
  });
};

/* harmony default export */ var Terms_TermsStep = ((0,next_router.withRouter)(TermsStep));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./src/utils/regex.tsx
var regex = __webpack_require__(37001);
// EXTERNAL MODULE: ./src/services/UserService.tsx
var UserService = __webpack_require__(92516);
// EXTERNAL MODULE: ./src/store/usePriorityAllocationStore.ts
var usePriorityAllocationStore = __webpack_require__(46674);
;// CONCATENATED MODULE: ./src/pages/Audience/BookingManager/Steps/Tickets/TicketsStep.tsx





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var colorArray = ["orange-pink", "pink-blue-teal", "blue-green-teal", "teal-green", "red-green-teal", "pink-purple-green"];

var TicketsStep = function TicketsStep(_ref) {
  var showId = _ref.showId,
      onNextButtonClick = _ref.onNextButtonClick,
      onPrevButtonClick = _ref.onPrevButtonClick,
      user = _ref.user,
      router = _ref.router,
      minAge = _ref.minAge,
      isPriorityActive = _ref.isPriorityActive,
      sessionId = _ref.sessionId,
      isLastMinPhase = _ref.isLastMinPhase;

  var _useModal = (0,ModalContext/* useModal */.dd)(),
      openModal = _useModal.openModal,
      closeModal = _useModal.closeModal,
      setCurrentTexts = _useModal.setCurrentTexts;

  var getAvailablePrioritySeats = (0,usePriorityAllocationStore/* usePriorityAllocationStore */.q)(function (state) {
    return state.getAvailablePrioritySeats;
  });

  var _React$useState = react.useState(1),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      ticketNumber = _React$useState2[0],
      setTicketNumber = _React$useState2[1];

  var _useState = (0,react.useState)(false),
      genericError = _useState[0],
      setGenericError = _useState[1];

  var _React$useState3 = react.useState(true),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      nextDisabled = _React$useState4[0],
      setNextDisabled = _React$useState4[1];

  var _useState2 = (0,react.useState)(false),
      checkingEmails = _useState2[0],
      setCheckingEmails = _useState2[1];

  var emptyBookingTicket = {
    firstName: "",
    lastName: "",
    email: "",
    age: 0,
    accessibility: '',
    otherAccessibility: null
  };
  var ticketFormCardRef = react.useRef(null);

  var triggerValidation = function triggerValidation() {
    if (ticketFormCardRef.current && ticketFormCardRef.current.validate) {
      ticketFormCardRef.current.validate();
    }
  };

  var _useState3 = (0,react.useState)({
    bookForAnotherPerson: false,
    loggedInUserTicket: {
      firstName: user === null || user === void 0 ? void 0 : user.firstName,
      lastName: user === null || user === void 0 ? void 0 : user.lastName,
      email: user === null || user === void 0 ? void 0 : user.email,
      age: user === null || user === void 0 ? void 0 : user.age,
      accessibility: user === null || user === void 0 ? void 0 : user.accessibility,
      otherAccessibility: user === null || user === void 0 ? void 0 : user.otherAccessibility
    },
    ticketForAnotherPerson: [],
    error: false
  }),
      userBookingTicket = _useState3[0],
      setUserBookingTicket = _useState3[1];

  (0,react.useEffect)(function () {
    var formValues = sessionStorage.getItem('formValues');
    var prePopulateForm = formValues ? JSON.parse(formValues) : null;
    setUserBookingTicket(_objectSpread(_objectSpread({}, userBookingTicket), {}, {
      ticketForAnotherPerson: prePopulateForm == null ? [] : prePopulateForm
    }));
    var ticketNumberStored = sessionStorage.getItem('ticketNumber');
    var prePopulateTicketNumber = ticketNumberStored ? JSON.parse(ticketNumberStored) : null;

    if (prePopulateTicketNumber !== null) {
      setTicketNumber(Number(prePopulateTicketNumber));

      if (Number(prePopulateTicketNumber) == 1) {
        setNextDisabled(false);
      }
    } else {
      setNextDisabled(false);
    }

    validateTicketHolders(prePopulateForm);
  }, []);

  var handleChangeTicketNumber = function handleChangeTicketNumber(ticketNumber) {
    setTicketNumber(ticketNumber);
    var otherTickets = JSON.parse(JSON.stringify(userBookingTicket.ticketForAnotherPerson));

    if (ticketNumber == 1) {
      otherTickets = [], setNextDisabled(false);
    } else {
      if (otherTickets.length >= ticketNumber) {
        otherTickets = otherTickets.slice(0, ticketNumber - 1);
      }

      if (otherTickets.length < ticketNumber - 1) {
        while (otherTickets.length < ticketNumber - 1) {
          otherTickets.push(emptyBookingTicket);
        }
      }
    }

    setUserBookingTicket(_objectSpread(_objectSpread({}, userBookingTicket), {}, {
      loggedInUserTicket: userBookingTicket.loggedInUserTicket,
      ticketForAnotherPerson: otherTickets
    }));
    validateTicketHolders(otherTickets);
  };

  var _handleFormChange = function handleFormChange(ticket, index) {
    var currentObjects = userBookingTicket.ticketForAnotherPerson;

    if ((currentObjects === null || currentObjects === void 0 ? void 0 : currentObjects.length) > 0) {
      currentObjects[index] = ticket;
      validateTicketHolders(currentObjects);
      setUserBookingTicket(_objectSpread(_objectSpread({}, userBookingTicket), {}, {
        ticketForAnotherPerson: currentObjects
      }));
    }
  };

  var validateTicketHolders = function validateTicketHolders(object) {
    for (var i in object) {
      if (!(object[i].firstName == "" || object[i].lastName == "" || object[i].age >= 18 && (object[i].email == "" || !(0,regex/* emailValidation */.D6)(object[i].email) || userBookingTicket.loggedInUserTicket.email === object[i].email) || object[i].age == 0 || object[i].accessibility == "")) {
        setNextDisabled(false);
        setGenericError(false);
      } else {
        setNextDisabled(true);
        break;
      }
    }
  };
  /**
   * A guest is only a dependant if they have no email of their own — everyone else gets their
   * own booking interest and has to accept their own offer, which they cannot do without an
   * account. So every address typed into a guest card is worth checking.
   */


  var guestEmails = function guestEmails() {
    return userBookingTicket.ticketForAnotherPerson.map(function (ticket) {
      var _ticket$email;

      return (_ticket$email = ticket.email) === null || _ticket$email === void 0 ? void 0 : _ticket$email.trim();
    }).filter(function (email) {
      return !!email && (0,regex/* emailValidation */.D6)(email);
    });
  };

  var handleNextButtonClick = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var availableSeats, emails, unregistered;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              sessionStorage.setItem("formValues", JSON.stringify(userBookingTicket.ticketForAnotherPerson));
              sessionStorage.setItem("ticketNumber", JSON.stringify(ticketNumber));

              if (!(isPriorityActive && sessionId)) {
                _context.next = 7;
                break;
              }

              availableSeats = getAvailablePrioritySeats(sessionId);

              if (!(availableSeats !== undefined && ticketNumber > availableSeats)) {
                _context.next = 7;
                break;
              }

              openModal(ModalContext/* Modals.NotEnoughPriorityTickets */.nK.NotEnoughPriorityTickets, function () {
                closeModal();
                onNextButtonClick(false);
              });
              return _context.abrupt("return");

            case 7:
              // Last check before the application leaves this step: an invited guest with no account
              // cannot accept the offer that gets sent to them, and the lead booker would otherwise only
              // find out when it expires. Warn, but never block — it is their booking.
              emails = guestEmails();

              if (!emails.length) {
                _context.next = 18;
                break;
              }

              setCheckingEmails(true);
              _context.next = 12;
              return (0,UserService/* getUnregisteredEmails */._d)(emails);

            case 12:
              unregistered = _context.sent;
              setCheckingEmails(false);

              if (!unregistered.length) {
                _context.next = 18;
                break;
              }

              setCurrentTexts({
                mainBody: "",
                recipientEmails: unregistered,
                isLastMinPhase: isLastMinPhase
              });
              openModal(ModalContext/* Modals.UnregisteredGuestEmails */.nK.UnregisteredGuestEmails, function () {
                closeModal();
                onNextButtonClick(isPriorityActive);
              });
              return _context.abrupt("return");

            case 18:
              onNextButtonClick(isPriorityActive);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleNextButtonClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleDisabledClick = function handleDisabledClick(event) {
    event.stopPropagation; // The button is wrapped in this div precisely so a click still registers while it is
    // disabled — which means a second click during the email check would run it twice.

    if (checkingEmails) {
      return;
    }

    if (nextDisabled) {
      setGenericError(true);
      triggerValidation();
    } else {
      setGenericError(false);
      handleNextButtonClick();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TicketContainer, {
    "data-cy": "ticketContainer",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* TitleSubtitle */.V9, {
      title: "How many tickets?",
      subTitle: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: ["Please make sure you have the ", /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Tooltip */.u, {
          tooltipName: "correctEmail",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledBlueSpan, {
            children: " correct email address "
          })
        }), "of any guest over 18. If you don't know their age it can be an estimate for now."]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* TicketNumberSelector */.uT, {
      size: 6 //TTT-795: Enable 6 instead of 4 tickets on Idol only for PROD
      ,
      maxTicketNumber: showId == 10 ? 6 : 4,
      defaultTicketNumber: ticketNumber,
      onTicketNumberChange: handleChangeTicketNumber
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* TicketFormCard */.t8, {
      index: -1,
      ticketNumber: 1,
      disabled: true,
      disabledIconTooltip: "editLocked",
      bookingTicket: userBookingTicket.loggedInUserTicket,
      isPriority: isPriorityActive,
      colour: isPriorityActive ? "strong-gold" : undefined
    }, 'userTicket-main'), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledForm, {
      children: [userBookingTicket.ticketForAnotherPerson.map(function (otherTicket, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* TicketFormCard */.t8, {
          "data-cy": "interest-form-row",
          index: index,
          bookingTicket: otherTicket,
          ticketNumber: index + 2,
          colour: isPriorityActive ? "strong-gold" : colorArray[index % colorArray.length],
          disabled: false,
          handleFormChange: function handleFormChange(ticket, index) {
            return _handleFormChange(ticket, index);
          },
          isPriority: isPriorityActive,
          minAge: minAge,
          loggedInUserEmail: userBookingTicket.loggedInUserTicket.email,
          ref: ticketFormCardRef
        }, "otherTickets-".concat(index));
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CTAButtonContainer, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
          size: "md",
          variant: "tertiary",
          onClick: function onClick() {
            return onPrevButtonClick();
          },
          "data-cy": "button-booking-previous",
          sx: {
            padding: 0
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ButtonContainer, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ButtonIcon, {
              icon: "ArrowLeft"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonLabel, {
              children: "Back"
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          onClick: handleDisabledClick,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* Button */.zx, {
            size: "md",
            gradientStyle: "gradient3",
            disabled: nextDisabled,
            loading: checkingEmails,
            "data-cy": "button-booking-next",
            children: ["Apply for ", ticketNumber, " Ticket", ticketNumber == 1 ? '' : 's']
          })
        })]
      }), genericError && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* InfoMessage */.$J, {
        hasBackground: true,
        variant: "error",
        message: "Hang fire!! Please address the issues highlighted above before continuing \uD83D\uDC46"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* MeshGradient */.bL, {
      sx: {
        position: 'fixed'
      },
      colour: "teal-green",
      position: "bottom",
      size: "low"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Modal */.u_, {})]
  });
};

/* harmony default export */ var Tickets_TicketsStep = ((0,next_router.withRouter)(TicketsStep));
;// CONCATENATED MODULE: ./src/pages/Audience/BookingManager/Success/Success.styles.ts


var SuccessContainer = (0,styled/* default */.ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    display: "flex",
    width: "400px",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.space._600,
    alignSelf: "strech",
    "@media (max-width: 600px)": {
      width: "100%"
    }
  };
});
var Success_styles_StyledBlueSpan = (0,styled/* default */.ZP)("span")(function (_ref2) {
  var theme = _ref2.theme;
  return {
    color: theme.colors["blue.400"]
  };
});
var TitleContainer = (0,styled/* default */.ZP)("div")(function (_ref3) {
  var theme = _ref3.theme;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.space._500,
    alignSelf: "strech"
  };
});
var ImageContainer = (0,styled/* default */.ZP)("div")(function (_ref4) {
  var theme = _ref4.theme;
  return {
    display: "flex",
    position: "relative",
    alignItems: "center",
    alignSelf: "strech",
    aspectRatio: 2.14,
    width: "100%",
    maxWidth: "338px",
    height: "auto"
  };
});
var SuccessImage = (0,styled/* default */.ZP)("div")(function (_ref5) {
  var theme = _ref5.theme;
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "strech",
    width: theme.space._1150,
    height: theme.space._1050
  };
});
var Title = (0,styled/* default */.ZP)(Typography/* default */.Z)(function (_ref6) {
  var theme = _ref6.theme;
  return {
    color: theme.colors["neutral.50"],
    textAlign: "center",
    fontSize: theme.fontSizes["3xl"],
    fontFamily: theme.fonts["default"],
    fontWeight: theme.fontWeights.bold,
    lineHeight: theme.lineHeights.slim
  };
});
var SubTitle = (0,styled/* default */.ZP)(Typography/* default */.Z)(function (_ref7) {
  var theme = _ref7.theme;
  return {
    color: theme.colors["neutral.50"],
    textAlign: "center",
    fontSize: theme.fontSizes["2xl"],
    fontFamily: theme.fonts["default"],
    fontWeight: theme.fontWeights.bold,
    lineHeight: theme.lineHeights.slim
  };
});
var EndingPhrase = (0,styled/* default */.ZP)(Typography/* default */.Z)(function (_ref8) {
  var theme = _ref8.theme;
  return {
    color: theme.colors["neutral.500"],
    fontFamily: theme.fonts["default"],
    fontSize: theme.fontSizes.md,
    fontWeight: theme.fontWeights.regular,
    lineHeight: theme.lineHeights.base
  };
});
var ContentContainer = (0,styled/* default */.ZP)("div")(function (_ref9) {
  var theme = _ref9.theme;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.space._400,
    alignSelf: "strech"
  };
});
var CTAContainer = (0,styled/* default */.ZP)("div")(function (_ref10) {
  var theme = _ref10.theme;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.space._600,
    alignSelf: "strech"
  };
});
;// CONCATENATED MODULE: ./src/pages/Audience/BookingManager/Success/Success.content.tsx






var ListContent = {
  Line1: /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: ["You can now find and", /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Tooltip */.u, {
      tooltipName: "manageBooking",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Success_styles_StyledBlueSpan, {
        children: " update "
      })
    }), "this ticket request in your profile under", /*#__PURE__*/(0,jsx_runtime.jsxs)((link_default()), {
      href: "/profile?tab=tickets",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Success_styles_StyledBlueSpan, {
        children: " Applications & Tickets "
      }), "."]
    })]
  }),
  Line2: /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: ["Ticket offers are usually sent out", /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Tooltip */.u, {
      tooltipName: "lastMinuteTickets",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Success_styles_StyledBlueSpan, {
        children: " 1 to 2 weeks "
      })
    }), "before the show date."]
  }),
  Line3: /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: ["You and your guests will have a", /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Tooltip */.u, {
      tooltipName: "ticketOfferExpiration",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Success_styles_StyledBlueSpan, {
        children: " limited time "
      })
    }), "to accept."]
  })
};
var ListArray = [ListContent.Line1, ListContent.Line2, ListContent.Line3];
/**
 * The last min list (TTT-688 §5): applications made after the last-min phase opens join a
 * queue that is served by SMS at short notice, so "offers go out 1 to 2 weeks before the
 * show" above is not just unhelpful here, it is wrong.
 */

var LastMinListArray = [ListContent.Line1, /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
  children: ["Offers for this session go out", /*#__PURE__*/(0,jsx_runtime.jsx)(Success_styles_StyledBlueSpan, {
    children: " at short notice "
  }), "- often on the day of the show, as seats are released."]
}, "last-min-timing"), /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
  children: ["We will", /*#__PURE__*/(0,jsx_runtime.jsx)(Success_styles_StyledBlueSpan, {
    children: " text you "
  }), "when a seat opens up, so keep your phone handy - you will only have a short time to confirm before it goes to the next person."]
}, "last-min-sms")];
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/pages/Audience/BookingManager/Success/Success.tsx


function Success_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Success_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Success_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Success_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Logo = function Logo(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", Success_objectSpread(Success_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M447.23 284.71c21.71 6.21 37.49 23.62 42.22 45.57q1.31 6.08 1.31 16.56-.02 44.58-.01 89.2c0 5.92-2.19 8.19-7.94 8.2l-12.03.02c-5.81 0-8.79-1.75-8.78-7.74q.02-45.08-.01-90.17-.01-8.28-1.38-12.52c-9.53-29.38-55.33-30.85-64.84-1.04q-1.31 4.12-1.3 11.55.1 45.61.02 91.2c-.01 5.5-1.65 8.65-7.4 8.69q-7.68.05-15.34 0c-4.46-.03-6-3.77-6-7.89V227.7c0-4.32 1.67-7.78 6.25-7.88q11.53-.26 16.01.01c5.25.31 6.47 4 6.48 8.83q.04 26.72 0 53.42c-.01 7.74 5.65 9.78 12.15 6.73 14.02-6.58 25.59-8.4 40.59-4.1zm378.75 18.13-5.05-75.62a.44.44 0 0 1 .44-.47h26.9a.44.44 0 0 1 .44.47l-5.35 75.62a.44.44 0 0 1-.44.41h-16.5a.44.44 0 0 1-.44-.41zM273.99 415.2c13.69 8.64 32.56-.23 33.75-17.08.39-5.58 1.95-8.04 7.62-8.09q6.4-.07 12.81-.02c10.81.08 8.92 9.29 7.07 17.21q-4.28 18.35-18.17 29.29c-20.83 16.4-50.34 13.9-68.44-5.24q-13.9-14.69-13.89-36.27.02-38.51.01-76.5a2.74 2.74 0 0 0-2.74-2.74q-15.49-.02-30.98-.01c-4.27.01-7.23-1.91-7.26-6.33q-.04-7.33-.02-14.66c.02-5.17 2.16-7.72 7.28-7.74q15.94-.04 31.24-.01a2.48 2.48 0 0 0 2.48-2.48q.01-24.15 0-49.03c0-5.33 3.48-7 8.46-7q6.23-.01 12.44.01c4.65.02 8.1 1.82 8.1 6.74v49.26a2.49 2.49 0 0 0 2.49 2.49h51.26c4.38 0 6.22 3.48 6.23 7.64q.02 6.76.03 13.5c.01 4.47-1.69 7.61-6.42 7.6q-25.53 0-50.77.02a2.82 2.81 0 0 0-2.82 2.81v76.18c.01 8.87 2.83 15.78 10.24 20.45zm457.47-129.04.55.46q.47.38 1.07.38 24.56 0 49.1.01c6.13 0 8.73 1.87 8.79 8 .08 6.91 1.37 16.82-2.69 19.61q-1.66 1.13-5.31 1.13H733.7a2.96 2.96 0 0 0-2.96 2.96q.03 37.06-.01 74.74 0 6.72 1.31 10.42c5.85 16.45 26.76 19.89 37.83 6.31q4.44-5.45 4.93-14.17c.29-5.02 4.58-5.98 9.07-6q6.69-.03 13.38 0c4.34.02 6.27 3.52 6.27 7.64-.01 15.79-8.46 30.97-20.77 39.9-29.5 21.43-70.79 6.01-79.39-29.08q-1.35-5.52-1.36-15.54v-74.02a3.15 3.15 0 0 0-3.14-3.15q-15.87-.04-32.11.01c-4.33.01-5.94-3.6-5.98-7.62q-.06-6.55-.01-13.11c.04-4.4 1.79-8.06 6.49-8.05q16.26.02 31.88 0a2.85 2.85 0 0 0 2.84-2.85q.03-24.3.04-48.24c0-4.81 2.13-7.38 6.92-7.39q7-.02 13.99-.01c5.43 0 7.81 2.32 7.82 7.59q.02 24.34 0 48.55a1.97 1.96 19.7 0 0 .72 1.52zm-118.21 62.16c5.09.04 3.5-8.85 3.52-12.07q.08-20.15-18.83-25.14c-9.67-2.56-26.42-1.63-34.46 5.05q-5.26 4.38-5.49 12.59-.12 4.13-5 4.3-6.65.22-13.3.19c-5.1-.03-9.47.41-9.88-5.48q-.63-9.15 4.3-18.9c7.77-15.36 27.35-24.06 44.01-26.03 27.61-3.28 59.28 6.97 66.02 37.51q1.29 5.86 1.32 19.92.09 47.8.02 95.61c-.01 5.39-1.83 8.29-7.35 8.36q-7.39.1-10.38.01c-6.37-.2-5.89-12.33-13.27-8.07-8.8 5.08-15.36 9.39-26.48 10.67-15.23 1.75-32.09-.94-44.71-9.4-26.55-17.78-28.2-60.42-2.06-79.28q8.72-6.29 19.61-8.58 5.86-1.23 19.91-1.3 16.25-.09 32.5.04zm-19.37 71.34q19.83-3.46 24.27-21.47c1.49-6.07 1.23-14.18 1.06-20.9a2.85 2.84 89.3 0 0-2.84-2.78q-20.92-.04-41.97.02c-10.5.02-19.79 4.17-22.33 15.24-2.82 12.3 1.81 24.93 14.44 29.17 8.27 2.78 19.14 2.15 27.37.72zm340.75-136.78c24.27 2.93 46.98 19.2 47.65 45.53.14 5.39-2.03 8.03-7.38 8.07q-6.29.05-12.58.02c-4.38-.03-8.5-1.18-8.78-6q-.37-6.63-2.79-10.34-4.46-6.82-12.39-8.99c-12.68-3.46-33.42-2.63-39.44 12.07q-3.6 8.77 4.14 15.18c5.09 4.2 13.7 5.93 20.97 7.15 30.66 5.11 65.02 12.39 64.33 52.05-.91 52.21-72.46 61.2-105.63 37.21-13.4-9.69-20.66-27-19.73-43.09.25-4.37 3.77-5.72 7.85-5.73q6.47-.03 12.95.01c4.21.02 8 1.7 7.99 6.23-.02 25.31 22.62 28.75 42.21 27.28 13.97-1.05 26.73-8.39 25.59-24.29-2.21-30.83-83.92-9.29-90.88-60.74-5.08-37.49 35.16-55.34 65.92-51.62zM460.57 605.39c-9.44-29.3-55.17-30.67-64.82-.95q-1.28 3.95-1.27 10.75.08 47.29.01 94.56c-.01 4.36-3.82 6-7.88 6q-6.58-.01-13.13.01c-5.11.02-7.73-1.85-7.73-7.02q0-104.85.01-209.71c0-3.78 1.73-7.47 5.73-7.5q7.45-.06 14.89-.02c5.44.04 8.09 2.19 8.1 7.61q.06 27.61.01 55.22c-.01 6.44 5.51 9.26 11.28 6.59 9.63-4.45 17.25-7.42 27.48-6.86 27.38 1.48 50.08 20.27 56.07 47.07q1.4 6.25 1.41 18.33.05 44.5 0 89c0 4.21-1.92 7.26-6.31 7.27l-14.71.02c-4.98.01-7.7-1.98-7.7-7.01q-.02-44.49-.01-88.98.01-9.91-1.43-14.38z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      x: "-16",
      y: "-16.13",
      transform: "rotate(.115 -290264.664 564080.533)",
      width: "32",
      height: "32.26",
      rx: "5.22"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M1266.16 608.54q.49.97 1.4.71.36-.11.82-.52 26.39-24.28 52.76-48.59c2.35-2.17 4.63-2.86 8.03-2.87q8.92-.03 17.84-.03c4.08.01 6.69 4.69 5.47 8.37q-.51 1.55-2.99 3.87-32.02 30.08-63.42 59.72-3.7 3.49-.03 7.02 35.98 34.51 72.31 69.43c2.89 2.78 1.09 7.58-2.01 9.27q-1.55.84-5.32.84-8.98 0-17.97-.03c-3.92-.02-6.55-1.26-9.21-3.82q-26.86-25.89-53.65-51.86-1.22-1.19-2.36-1.83a1.23 1.23 0 0 0-1.83 1.07q-.01 24.84 0 49.96c0 4.53-3.04 6.45-7.42 6.48q-6.99.04-13.98.02c-4.53-.01-7.34-2.04-7.34-6.65q-.01-104.57-.01-209.14c0-5.87 1.8-8.41 7.7-8.44q7.27-.03 14.56-.04c4.85 0 6.48 3.89 6.48 8.36q.02 53.93.01 108a1.62 1.59-58.5 0 0 .16.7zM234.72 556.31q.1-24.09.01-48.81-.02-7.1 7.26-7.3 6.45-.17 12.89-.18c6.23 0 8.84 2.1 8.85 8.29q.04 23.85.01 47.66a2.79 2.79 0 0 0 2.79 2.79q24.8-.02 49.86.01c4.51 0 7.36 2.01 7.36 6.62q-.01 6.87.01 13.71c.02 5.64-1.65 8.38-7.42 8.39q-25.16.03-50.1.01a2.48 2.48 0 0 0-2.49 2.48q0 37.04-.01 74.7 0 7.52 1.23 10.99c5.71 16.07 26.55 19.59 37.46 6.77q4.97-5.84 5.35-14.69c.2-4.65 3.87-5.99 8.16-5.99l14.31-.02c5.17-.01 6.43 4.38 6.23 8.9-1.06 23.13-17.98 42.57-40.23 47.35-32.47 6.96-61.51-18.38-61.5-50.99q.01-38.87 0-77.01a2.48 2.48 0 0 0-2.48-2.48q-16.02-.03-32.52 0c-4.68.01-6-4.01-6.01-8.22q-.01-6.54.03-13.08c.04-5.11 2.23-7.47 7.23-7.46q15.75.02 31.28-.01a2.44 2.44 0 0 0 2.44-2.43zm658.32 129.73q-6.53 16.64-20.92 25.46c-29.42 18.02-68.14 2-75.99-31.29q-1.39-5.91-1.39-17.53.02-36.2.01-72.23a2.95 2.95 0 0 0-2.95-2.95q-14.66-.01-29.91 0c-5.54 0-8.37-1.68-8.38-7.39q-.02-6.65 0-13.28c.01-5.42 1.84-8.07 7.33-8.07q15.79-.01 30.96-.01a2.96 2.95-89.9 0 0 2.95-2.95q.01-23.74-.01-47.67c0-5.66 2.12-8.03 7.66-8.1q6.11-.07 12.23-.02c6.35.06 8.87 1.97 8.87 8.31v47.73a2.7 2.7 0 0 0 2.7 2.7q24.5.01 49.41 0c5.53 0 8.05 2.18 8.11 7.62q.08 6.34.01 12.68c-.05 5.64-1.91 8.44-7.66 8.44q-25.03.03-49.87.01a2.69 2.69 0 0 0-2.7 2.69v73.52q0 8.52 1.44 12.37c4.01 10.7 15.87 16.66 26.95 13.18q12.06-3.78 15.27-16.79c.98-3.95-.56-7.44 3.66-9.87 3.08-1.78 13.09-.86 16.96-.85q3.76 0 5.32.76c6.16 2.97 2.06 18.12-.06 23.53zm704.77-96.02a1.74 1.68 53.5 0 0-.06.45q-.01 36.62.01 73.3 0 8.43 1.45 12.26c4.13 10.9 16.3 16.86 27.54 13.07q11.22-3.79 14.67-16.22c1.07-3.87-.64-8.2 4.04-10.48q1.26-.61 3.7-.63 6.66-.05 13.33-.02c9.38.05 8.75 6.71 7.67 13.8-2.04 13.36-9.14 25.19-19.68 33.16-29.44 22.24-71.56 6.77-80.11-28.84q-1.36-5.71-1.37-16.35-.01-36.63 0-73.13a2.88 2.87-90 0 0-2.87-2.88q-14.74-.03-29.99 0c-5.43.01-8.32-1.85-8.37-7.4q-.06-7.68 0-15.36c.04-4.57 4.02-5.99 8.19-5.99q15.35-.01 30.16-.01a2.87 2.87 0 0 0 2.87-2.87q.03-23.29 0-47.12c-.01-5.87 1.75-8.68 7.74-8.73q7.26-.07 14.52-.02c5.08.04 6.49 4.01 6.5 8.62q.01 23.57 0 47.21a2.91 2.91 0 0 0 2.91 2.92q24.53-.02 49.65.01c4.89 0 7.57 2.04 7.65 6.94q.11 7.13 0 14.25c-.07 4.64-2.18 7.51-6.9 7.52q-24.82.05-49.64.01c-1.89 0-3.13.58-3.61 2.53zm-950.72 93.05c-6.26 16.07-19.81 27.49-36.13 32.53-36.66 11.34-75.66-5.49-85.56-44.34q-1.71-6.71-2.27-17.64-.94-18.36.15-37.62c2.6-45.81 42.98-70.96 86.18-59.23 23.5 6.37 38.1 24.16 41.65 47.84 1.46 9.77.95 22.47.87 33.49-.03 4.61-1.84 7.64-6.66 7.64q-45.03.02-90.07.01-3.27 0-3.33 3.24c-.37 20.37 8.11 37.85 30.07 40.9q13.47 1.87 24.44-3.48 10.78-5.27 15.18-17.55c1-2.8 3.96-3.81 6.96-3.83q7.44-.05 14.89-.03c3.75.01 6.95.98 6.78 5.25q-.22 5.31-3.15 12.82zm-91.4-62.69 65.76-.22a3.15 3.15 0 0 0 3.13-3.17v-1.02a34.57 33.33-.2 0 0-34.69-33.2l-2.92.01a34.57 33.33-.2 0 0-34.45 33.45v1.02a3.15 3.15 0 0 0 3.17 3.13zm556.25-62.46c37.25-12.69 84.39 5.95 84.89 50.31.06 5.34-3.67 6.3-8.35 6.28q-7.38-.02-14.71-.13c-4.83-.07-5.52-2.66-5.86-7.08-1.36-17.38-18.68-24.96-33.98-24.54-13.55.37-25.39 7.43-30.55 20.17q-2.35 5.8-2.96 17-.88 15.93-.07 31.87.66 12.85 3.25 19.02c6.21 14.81 22.04 21.12 37.78 19.15 13.26-1.66 25.63-10.51 26.32-25 .19-3.81 1.32-6.19 5.31-6.39q4.66-.22 15.16-.07c6.07.09 8.81 2.14 8.58 8.29-1.46 38.07-38.71 56.69-72.75 51.34-25.65-4.03-43.94-21.73-50.1-46.9q-1.62-6.6-2.27-18.12-1.28-22.5.64-42.37c2.24-23.13 17.33-45.22 39.67-52.83zm333.93 160.91c-37.6 2.4-67.62-22.04-70.12-60.09q-1.56-23.64-.17-44.49c1.98-29.65 22.3-53.91 51.92-59.13 40.03-7.05 75.8 15.67 76.63 58.63q.4 20.76.05 26.5c-.26 4.23-4.09 5.5-8 5.5H1407c-2.13 0-2.98 1.8-2.98 3.79q.01 9.43 2.03 15.98 7.34 23.88 32.71 24.9c13.32.54 27.61-5.04 33.56-17.68 2.29-4.86 2.24-7.7 8.87-7.73q7.42-.02 14.83-.01c4.83 0 7.03 2.09 6.24 6.89-4.72 28.63-28.73 45.18-56.39 46.94zm-38-98.46 65.86-.23a3.09 3.09 0 0 0 3.07-3.1v-1.13a34.56 33.26-.2 0 0-34.68-33.13l-2.92.01a34.56 33.26-.2 0 0-34.44 33.38v1.13a3.09 3.09 0 0 0 3.11 3.07zm-408.78 66.78c.71 1.2 1.87 1.6 3.29 1.6h38.05c5.45 0 7.99 1.87 8.04 7.33q.06 5.88.02 11.77c-.03 4.47-1.58 7.89-6.43 7.89q-57.9.02-115.79.01c-5.21 0-7.93-1.73-7.99-7.06q-.07-6.96-.03-13.95c.03-4.24 3.6-5.96 7.6-5.97q20.36-.04 40.61-.01a2.79 2.79 0 0 0 2.79-2.79v-98.95a2.78 2.77.1 0 0-2.77-2.77q-18.46-.01-37.01 0c-4.92.01-7.88-1.61-7.94-6.75q-.08-6.48-.01-12.96c.04-4.22 1.89-7.28 6.32-7.28q31.54-.02 63.07-.01c5.52.01 7.83 2.22 7.83 7.6q.02 60.56.01 121.05a2.48 2.46 30 0 0 .34 1.25zm63.17 218.78c-55.41-1.12-97.06-31.32-125.13-77.23q-3.84-6.27-4.39-9.94c-2-13.41 14.1-22.54 24.9-14.76q2.01 1.45 5.5 6.2c23.85 32.44 53.2 54.88 94.99 56.85q6.81.33 13.62.15c42.24-1.12 73.53-22.77 97.48-55.96q4.18-5.79 6.32-7.32c10.73-7.68 26.53 1.24 24.84 14.64q-.47 3.7-3.93 9.4c-13.22 21.74-30.4 41.8-51.76 55.69-24.98 16.24-52.67 22.89-82.44 22.28z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      style: {
        fontWeight: "700",
        fontSize: "122.5px",
        fontFamily: "Monospace",
        InkscapeFontSpecification: "'Monospace Bold'",
        fill: "#fff",
        strokeWidth: "13.125"
      },
      d: "M1537.917 842.137q0-10.467 3.47-21.174 2.571-7.895 7.954-17.585 3.888-6.939 5.743-8.494 1.854-1.615 4.127-1.615 2.632 0 4.426 1.794 1.794 1.795 1.794 4.307 0 1.735-1.435 4.127-6.46 10.587-9.45 19.859-2.932 9.27-2.932 18.781 0 9.57 2.931 18.842 2.991 9.271 9.451 19.858 1.435 2.333 1.435 4.127 0 2.513-1.794 4.307-1.794 1.795-4.426 1.795-2.213 0-3.888-1.436-2.393-2.094-6.34-9.39-5.683-10.588-7.776-17.467-3.29-10.527-3.29-20.636zm62.446-47.791v27.514q4.486-2.93 9.092-4.366 4.665-1.496 9.39-1.496 12.741 0 21.594 8.793 8.852 8.793 8.852 21.234 0 11.903-8.434 19.918-8.433 7.956-22.25 7.956-4.905 0-9.451-1.256t-8.793-3.709v2.99h-14.355q-4.427 0-6.34-1.674-1.855-1.734-1.855-4.486 0-2.692 1.914-4.366 1.914-1.735 6.28-1.735h2.094v-53.055h-2.093q-4.427 0-6.34-1.675-1.855-1.735-1.855-4.486 0-2.692 1.854-4.367 1.914-1.734 6.34-1.734zm36.666 52.038q0-7.596-5.323-12.86-5.324-5.264-13.04-5.264-7.656 0-12.98 5.264-5.323 5.264-5.323 12.68 0 6.76 4.785 11.126 4.785 4.307 13.518 4.307t13.518-4.307q4.845-4.366 4.845-10.946zm83.083 4.606h-50.304q1.914 4.785 6.759 7.716 4.905 2.93 13.219 2.93 6.819 0 18.123-2.93 4.666-1.196 6.46-1.196 2.453 0 4.128 1.734 1.674 1.735 1.674 4.367 0 2.392-1.794 4.067-2.393 2.213-11.664 4.247-9.271 1.974-17.825 1.974-14.714 0-23.566-8.314-8.793-8.315-8.793-20.457 0-12.92 9.51-20.995 9.57-8.135 22.012-8.135 7.477 0 13.698 2.632 6.28 2.632 9.33 5.683 4.307 4.426 7.119 10.946 1.914 4.546 1.914 10.527zm-13.578-12.262q-2.812-5.264-7.357-7.836-4.546-2.632-10.827-2.632-6.22 0-10.766 2.632-4.546 2.572-7.417 7.836zm53.294-8.853v24.584q0 3.948 1.615 5.204 2.513 1.974 8.973 1.974 9.39 0 17.346-4.008 3.05-1.555 4.785-1.555 2.393 0 4.127 1.795 1.795 1.794 1.795 4.366 0 2.393-1.914 4.127-2.931 2.811-11.604 5.204-8.614 2.333-14.535 2.333-11.425 0-17.167-4.905-5.683-4.965-5.683-12.142v-26.977h-4.426q-4.426 0-6.34-1.674-1.854-1.735-1.854-4.487 0-2.691 1.854-4.366 1.914-1.735 6.34-1.735h4.426v-11.065q0-4.427 1.675-6.28 1.735-1.915 4.486-1.915 2.692 0 4.367 1.914 1.734 1.854 1.734 6.28v11.066h22.67q4.426 0 6.28 1.735 1.915 1.675 1.915 4.426 0 2.692-1.914 4.427-1.855 1.674-6.28 1.674zm87.569 42.05v-2.871q-4.606 2.452-10.169 3.649-5.562 1.256-10.108 1.256-9.87 0-16.03-5.204-6.161-5.264-6.161-11.604 0-7.716 7.835-14.296 7.896-6.64 21.773-6.64 5.562 0 12.86 1.197v-2.93q0-2.752-2.393-4.487-2.332-1.735-8.972-1.735-5.443 0-14.116 2.154-3.23.777-5.024.777-2.453 0-4.187-1.734-1.675-1.795-1.675-4.546 0-1.555.598-2.692.598-1.136 1.675-1.794 1.076-.718 4.486-1.675 4.546-1.256 9.27-1.974 4.726-.778 8.554-.778 11.425 0 17.706 4.965 6.34 4.905 6.34 13.458v25.242h2.093q4.427 0 6.28 1.735 1.915 1.674 1.915 4.426 0 2.692-1.914 4.426-1.854 1.675-6.28 1.675zm0-21.952q-7.357-1.436-13.578-1.436-7.477 0-12.86 3.65-3.35 2.332-3.35 4.725 0 1.734 1.615 2.81 2.991 1.975 8.195 1.975 4.426 0 9.989-1.735 5.622-1.735 9.989-4.725zm67.71-7.836q0 10.468-3.47 21.234-2.571 7.896-7.955 17.526-3.888 6.939-5.742 8.554-1.854 1.615-4.127 1.615-2.632 0-4.426-1.795-1.795-1.794-1.795-4.307 0-1.794 1.436-4.127 6.46-10.587 9.39-19.858 2.991-9.271 2.991-18.842 0-9.51-2.99-18.781-2.931-9.272-9.391-19.859-1.436-2.392-1.436-4.127 0-2.512 1.795-4.307 1.794-1.794 4.426-1.794 2.213 0 3.888 1.435 2.392 2.034 6.34 9.391 5.682 10.588 7.776 17.406 3.29 10.588 3.29 20.636z"
    })]
  }));
};

Logo.defaultProps = {
  width: "150",
  height: "80",
  viewBox: "0 0 1920 1050",
  fill: "#FCFCFC",
  xmlns: "http://www.w3.org/2000/svg"
};



/**
 * "lastMin" is for an application that landed in the last min queue rather than the request
 * queue — same three steps, but the offer arrives by SMS at short notice instead of weeks
 * ahead, so the standard copy would set the wrong expectation.
 */




var Success = function Success(_ref) {
  var firstName = _ref.firstName,
      bookingInterestId = _ref.bookingInterestId,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "standard" : _ref$variant;
  var router = (0,next_router.useRouter)();
  var isLastMin = variant === "lastMin";

  var redirectToAddSession = function redirectToAddSession() {
    router.reload();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SuccessContainer, {
    "data-cy": "booking-interest-registration-success",
    "data-cy-variant": variant,
    "data-bookinginterest-id": bookingInterestId,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TitleContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SuccessImage, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Logo, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
        children: isLastMin ? "You\u2019re on the Last Minute List ".concat(firstName, "!") : "You\u2019re on the List for Tickets ".concat(firstName, "!")
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SubTitle, {
        children: "So, What Happens Now?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ImageContainer, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: "/images/email/progress-red-carpet-application.png",
          fill: true,
          alt: "Progress bar - applied for tickets step"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* List */.aV, {
        elements: isLastMin ? LastMinListArray : ListArray
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CTAContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(EndingPhrase, {
        children: "Want to increase your chances of getting tickets?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
        onClick: function onClick() {
          return router.reload();
        },
        "data-cy": "book-another-ticket-button",
        children: " Apply for another Session "
      })]
    })]
  });
};

/* harmony default export */ var Success_Success = ((0,next_router.withRouter)(Success));
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./src/services/SessionService.tsx
var SessionService = __webpack_require__(31681);
// EXTERNAL MODULE: ./src/pages/Audience/BookingManager/Steps/Session/BookingInterestErrorDialog/BookingInterestErrorDialog.module.scss
var BookingInterestErrorDialog_module = __webpack_require__(90863);
var BookingInterestErrorDialog_module_default = /*#__PURE__*/__webpack_require__.n(BookingInterestErrorDialog_module);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js
var Dialog = __webpack_require__(64666);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(37645);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(6514);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogContentText/DialogContentText.js + 1 modules
var DialogContentText = __webpack_require__(58951);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogActions/DialogActions.js + 1 modules
var DialogActions = __webpack_require__(31425);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/AutoAwesome.js
var AutoAwesome = __webpack_require__(43927);
;// CONCATENATED MODULE: ./src/pages/Audience/BookingManager/Steps/Session/BookingInterestErrorDialog/BookingInterestErrorDialog.tsx







var BookingInterestErrorDialog = function BookingInterestErrorDialog(props) {
  var open = props.open,
      setOpen = props.setOpen,
      handleCancelButtonClick = props.handleCancelButtonClick,
      handleAcceptButtonClick = props.handleAcceptButtonClick,
      dialogTitle = props.dialogTitle,
      dialogBody = props.dialogBody,
      dialogAcceptButtonText = props.dialogAcceptButtonText,
      dialogCancelButtonText = props.dialogCancelButtonText;

  var handleClose = function handleClose() {
    setOpen(false);

    if (handleCancelButtonClick) {
      handleCancelButtonClick();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
    maxWidth: "md",
    open: open,
    onClose: handleClose,
    className: (BookingInterestErrorDialog_module_default()).bookingInterestErrorDialog,
    "data-cy": "booking-interest-error-dialog",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
      id: "alert-dialog-title",
      className: (BookingInterestErrorDialog_module_default()).title,
      "data-cy": "booking-interest-error-dialog-title",
      children: dialogTitle
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DialogContentText/* default */.Z, {
        id: "alert-dialog-description",
        style: {
          whiteSpace: 'pre-line'
        },
        children: dialogBody
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
      children: [dialogCancelButtonText && /*#__PURE__*/(0,jsx_runtime.jsxs)(Button/* default */.Z, {
        onClick: handleClose,
        className: (BookingInterestErrorDialog_module_default()).cancelButton,
        variant: "outlined",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AutoAwesome/* default */.Z, {}), dialogCancelButtonText, /*#__PURE__*/(0,jsx_runtime.jsx)(AutoAwesome/* default */.Z, {})]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        onClick: function onClick() {
          handleAcceptButtonClick();
        },
        variant: "contained",
        "data-cy": "booking-interest-error-dialog-accept-button",
        children: dialogAcceptButtonText
      })]
    })]
  });
};

/* harmony default export */ var BookingInterestErrorDialog_BookingInterestErrorDialog = (BookingInterestErrorDialog);
// EXTERNAL MODULE: ./src/pages/Audience/BookingManager/Steps/Session/SessionStep.styles.ts
var SessionStep_styles = __webpack_require__(94826);
;// CONCATENATED MODULE: ./src/pages/Audience/BookingManager/Steps/Session/SessionStep.tsx
















var SessionStep = function SessionStep(_ref) {
  var _show$imageUrl;

  var router = _ref.router,
      show = _ref.show,
      promoCode = _ref.promoCode,
      user = _ref.user,
      onNextButtonClick = _ref.onNextButtonClick,
      _onRegisterSuccess = _ref.onRegisterSuccess;

  var _useState = (0,react.useState)(null),
      sessions = _useState[0],
      setSessions = _useState[1];

  var _useState2 = (0,react.useState)(null),
      selectedSession = _useState2[0],
      setSeletedSession = _useState2[1];

  var _useState3 = (0,react.useState)(undefined),
      selectedSessionId = _useState3[0],
      setSelectedSessionId = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      promoCodeError = _useState4[0],
      setPromoCodeError = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      promoCodeErrorDialogOpen = _useState5[0],
      setPromoCodeErrorDialogOpen = _useState5[1];

  var _useState6 = (0,react.useState)(""),
      promoCodeErrorDialogTitle = _useState6[0],
      setPromoCodeErrorDialogTitle = _useState6[1];

  var _useState7 = (0,react.useState)(""),
      promoCodeErrorDialogBody = _useState7[0],
      setPromoCodeErrorDialogBody = _useState7[1];

  var _useState8 = (0,react.useState)(""),
      promoCodeErrorDialogAcceptButtonText = _useState8[0],
      setPromoCodeErrorDialogAcceptButtonText = _useState8[1];

  var _useState9 = (0,react.useState)(""),
      promoCodeErrorDialogCancelButtonText = _useState9[0],
      setPromoCodeErrorDialogCancelButtonText = _useState9[1];

  var _useState10 = (0,react.useState)(),
      handlePromoCodeErrorDialogCancelButtonClick = _useState10[0],
      setPromoCodeErrorDialogHandleCancelButtonClick = _useState10[1];

  var _useState11 = (0,react.useState)(function () {
    return function () {
      return setPromoCodeErrorDialogOpen(false);
    };
  }),
      handlePromoCodeErrorDialogAcceptButtonClick = _useState11[0],
      setPromoCodeErrorDialogHandleAcceptButtonClick = _useState11[1];

  var _useModal = (0,ModalContext/* useModal */.dd)(),
      openModal = _useModal.openModal,
      closeModal = _useModal.closeModal,
      modalState = _useModal.modalState;

  var priorityAllocFullSessions = (0,usePriorityAllocationStore/* usePriorityAllocationStore */.q)(function (state) {
    return state.priorityAllocFullSessions;
  });
  (0,react.useEffect)(function () {
    if (show) {
      if (show.sessionCount != 0) {
        readAllSessions(true);
      } else {
        setSessions([]);
      }
    }
  }, [show]);

  var checkPromoCode = function checkPromoCode(currentSessions) {
    if (!promoCode) return;

    if (!currentSessions.some(function (s) {
      return s.isPriorityActive == true;
    })) {
      openPromoCodeErrorDialogAfterPageLoading();
      setPromoCodeErrorDialogTitle("Priority Registration deadline expired");
      setPromoCodeErrorDialogBody("We regret to inform you that the deadline for priority ticket registration has expired. However, regular ticket registration is still available. \n \nWe apologize for any inconvenience caused and appreciate your understanding. Thank you for your continued support!");
    } else if (!currentSessions.some(function (s) {
      return s.isPriorityActive == true && s.isPrioritySeatAvailable == true;
    })) {
      setPromoCodeErrorDialogTitle("Priority Tickets Fully Booked :(");
      setPromoCodeErrorDialogBody("We regret to inform you that all priority tickets have been fully booked. However, regular ticket registration is still available. \n \nWe apologize for any inconvenience caused and appreciate your understanding. Thank you for your continued support!");
      openPromoCodeErrorDialogAfterPageLoading();
    }
  };

  var openPromoCodeErrorDialogAfterPageLoading = function openPromoCodeErrorDialogAfterPageLoading() {
    setPromoCodeErrorDialogAcceptButtonText("Check Available Sessions");
    setPromoCodeErrorDialogCancelButtonText("");
    setPromoCodeErrorDialogOpen(true);
    setPromoCodeErrorDialogHandleCancelButtonClick(undefined);
    setPromoCodeErrorDialogHandleAcceptButtonClick(function () {
      return function () {
        return setPromoCodeErrorDialogOpen(false);
      };
    });
    setPromoCodeError(true);
  };

  var openPromoCodeErrorDialogOnSessionCardClick = function openPromoCodeErrorDialogOnSessionCardClick(session) {
    setPromoCodeErrorDialogTitle("Session not eligible for priority promotion");
    setPromoCodeErrorDialogBody("The session you have selected is not part of the priority promotion. While you can proceed with regular ticket booking, please note that ticket availability is not guaranteed for this session.");
    setPromoCodeErrorDialogAcceptButtonText("Proceed with regular booking");
    setPromoCodeErrorDialogCancelButtonText("View Eligible Sessions");
    setPromoCodeErrorDialogOpen(true);
    setPromoCodeErrorDialogHandleCancelButtonClick(function () {
      return function () {
        return setPromoCodeErrorDialogOpen(false);
      };
    });
    setPromoCodeErrorDialogHandleAcceptButtonClick(function () {
      return function () {
        handleBookingInterestRegistration(session);
      };
    });
  };

  var onSessionCardClickHandler = function onSessionCardClickHandler(session) {
    if (promoCode && !promoCodeError && (!session.isPriorityActive || !session.isPrioritySeatAvailable)) {
      openPromoCodeErrorDialogOnSessionCardClick(session);
    } else {
      handleBookingInterestRegistration(session);
    }
  };

  var handleBookingInterestRegistration = function handleBookingInterestRegistration(session) {
    setSeletedSession(session);
    setSelectedSessionId(session === null || session === void 0 ? void 0 : session.id);

    if (selectedSessionId === (session === null || session === void 0 ? void 0 : session.id)) {
      //resets the selected session to null if you toggle
      setSeletedSession(null);
      setSelectedSessionId(undefined);
    }
  };

  var readAllSessions = function readAllSessions(onInit) {
    var _show$id;

    setSessions(null);
    (0,SessionService/* readSessionsAudience */.nn)(show === null || show === void 0 ? void 0 : (_show$id = show.id) === null || _show$id === void 0 ? void 0 : _show$id.toString(), '1000', promoCode, new Date().toJSON()).then(function (sessionResponse) {
      if (sessionResponse.data) {
        var currentSessions = sessionResponse.data.sort(function (a, b) {
          return dayjs_min_default()(a.sortIndex).diff(dayjs_min_default()(b.sortIndex));
        });
        var activeSessionDates = currentSessions.map(function (session) {
          return new Date(session.arrivalTime);
        });
        activeSessionDates.forEach(function (session) {
          return session.setHours(0, 0, 0, 0);
        });
        setSessions(currentSessions);
        checkPromoCode(currentSessions);
      }
    });
  };

  var handleApplyForTicketsAndNextStep = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _priorityAllocFullSes;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(selectedSession !== null && selectedSession !== void 0 && selectedSession.id)) {
                _context.next = 5;
                break;
              }

              if (!((_priorityAllocFullSes = priorityAllocFullSessions[selectedSession.id]) !== null && _priorityAllocFullSes !== void 0 && _priorityAllocFullSes.isFull)) {
                _context.next = 4;
                break;
              }

              openModal(ModalContext/* Modals.NonPrioritySessionSelected */.nK.NonPrioritySessionSelected, function (successful) {
                if (successful) {
                  closeModal();
                  setSeletedSession(null);
                  setSelectedSessionId(undefined);
                } else {
                  closeModal();
                  onNextButtonClick(selectedSession === null || selectedSession === void 0 ? void 0 : selectedSession.id, true);
                }
              });
              return _context.abrupt("return");

            case 4:
              onNextButtonClick(selectedSession === null || selectedSession === void 0 ? void 0 : selectedSession.id);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleApplyForTicketsAndNextStep() {
      return _ref2.apply(this, arguments);
    };
  }();

  var isPriority = Object.values(priorityAllocFullSessions).some(function (value) {
    return value.isFull === false;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledEngineProvider/* default */.Z, {
    injectFirst: true,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(SessionStep_styles/* GlobalContainer */.iI, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageBox */.FS, {
        src: (_show$imageUrl = show === null || show === void 0 ? void 0 : show.imageUrl) !== null && _show$imageUrl !== void 0 ? _show$imageUrl : "",
        alt: "".concat(show === null || show === void 0 ? void 0 : show.name, " Image"),
        variant: "header"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SessionStep_styles/* PageContainer */._z, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SessionStep_styles/* MaxWidthContainer */.ah, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShowHeroDetails */.dO, {
            isPriority: isPriority,
            showTitle: show === null || show === void 0 ? void 0 : show.name,
            showSynopsis: show === null || show === void 0 ? void 0 : show.synopsis
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SessionSelection */.c4, {
            showName: show === null || show === void 0 ? void 0 : show.name,
            showMinimumAge: show === null || show === void 0 ? void 0 : show.defaultMinimumAgeRequirement,
            sessions: sessions,
            onSessionCardClickHandler: onSessionCardClickHandler,
            selectedSessionId: selectedSessionId
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* InfoPanel */.VJ, {
            title: "How Do I Get Tickets?",
            id: "#more-info",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(SessionStep_styles/* ListContainer */.Vm, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* TitleSubtitleList */.L9, {
                number: 1,
                title: "Join us!",
                subTitle: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                  children: ["There is no catch \u2013 membership is free, tickets are free and we will never sell your data. ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Be the first to know when new opportunities arise and the more shows you attend, the better the perks!"]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* TitleSubtitleList */.L9, {
                number: 2,
                title: "Register Your Interest!",
                subTitle: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                  children: ["Select the session you would like to attend and the number of tickets you need. ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Tell us the name and age of your guests and if they have any accessibility requirements. ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "You can change their details later if you need to. ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "You\u2019ve not got tickets yet but you are one step closer!"]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* TitleSubtitleList */.L9, {
                number: 3,
                title: "Hold tight!",
                subTitle: "If your session is sending out ticket offers you may be able to accept a ticket offer straight away. In all other cases keep an eagle eye on your email inbox (don\u2019t forget to check your spam folder too!). You can always login to your account and check the status of your ticket request as well."
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* TitleSubtitleList */.L9, {
                number: 4,
                title: "Accept your ticket offer!",
                subTitle: "If you receive a ticket offer you will only have 48 hours to accept!"
              })]
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SessionSelectionWidget */.lj, {
          showName: show === null || show === void 0 ? void 0 : show.name,
          selectedSession: selectedSession,
          setSeletedSession: setSeletedSession,
          setSelectedSessionId: setSelectedSessionId,
          onNextButtonClick: /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
            return regenerator_default().wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return handleApplyForTicketsAndNextStep();

                  case 2:
                    return _context2.abrupt("return", _context2.sent);

                  case 3:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          })),
          onRegisterSuccess: function onRegisterSuccess(email, firstName) {
            if (_onRegisterSuccess && selectedSession) {
              _onRegisterSuccess(email, firstName, selectedSession);
            }
          },
          user: user
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BookingInterestErrorDialog_BookingInterestErrorDialog, {
          open: promoCodeErrorDialogOpen,
          setOpen: setPromoCodeErrorDialogOpen,
          dialogTitle: promoCodeErrorDialogTitle,
          dialogBody: promoCodeErrorDialogBody,
          dialogAcceptButtonText: promoCodeErrorDialogAcceptButtonText,
          dialogCancelButtonText: promoCodeErrorDialogCancelButtonText,
          handleCancelButtonClick: handlePromoCodeErrorDialogCancelButtonClick,
          handleAcceptButtonClick: handlePromoCodeErrorDialogAcceptButtonClick
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Modal */.u_, {})]
    })
  });
};

/* harmony default export */ var Session_SessionStep = ((0,next_router.withRouter)(SessionStep));
// EXTERNAL MODULE: ./src/contexts/RegisterContext.tsx
var RegisterContext = __webpack_require__(72078);
// EXTERNAL MODULE: ./src/components/Register/index.ts + 3 modules
var Register = __webpack_require__(1837);
// EXTERNAL MODULE: ./src/components/Register/Password/Password.tsx + 1 modules
var Password = __webpack_require__(91610);
// EXTERNAL MODULE: ./src/components/Register/DateOfBirth/DateOfBirth.tsx
var DateOfBirth = __webpack_require__(44404);
// EXTERNAL MODULE: ./src/components/Register/Address/Address.tsx + 1 modules
var Address = __webpack_require__(21492);
// EXTERNAL MODULE: ./src/components/Register/Accessibility/Accessibility.tsx
var Accessibility = __webpack_require__(76087);
// EXTERNAL MODULE: ./src/components/Register/Gender/Gender.tsx + 1 modules
var Gender = __webpack_require__(98361);
// EXTERNAL MODULE: ./src/components/Register/PhoneNumber/PhoneNumber.tsx
var PhoneNumber = __webpack_require__(92788);
// EXTERNAL MODULE: ./src/components/Register/PhoneNumberVerification/PhoneNumberVerification.tsx
var PhoneNumberVerification = __webpack_require__(61677);
;// CONCATENATED MODULE: ./src/pages/Audience/BookingManager/Steps/Registration/BookingRegistrationFlow.styles.ts

var RegistrationFlowContainer = (0,styled/* default */.ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    position: "relative",
    maxWidth: "1440px",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: theme.space._1000,
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: theme.space._700,
    padding: "0 ".concat(theme.space._900),
    "@media (max-width: 900px)": {
      flexDirection: "column",
      alignItems: "center",
      padding: "0 ".concat(theme.space._400)
    }
  };
});
var RegistrationStepContainer = (0,styled/* default */.ZP)("div")(function (_ref2) {
  var theme = _ref2.theme;
  return {
    display: "flex",
    flexDirection: "column"
  };
});
var SessionPanelContainer = (0,styled/* default */.ZP)("div")(function (_ref3) {
  var theme = _ref3.theme;
  return {
    position: "sticky",
    top: "5rem",
    height: "min-content",
    maxWidth: theme.space._1300,
    borderRadius: "1rem",
    overflow: "hidden",
    background: theme.colors["neutral.900"],
    zIndex: 0,
    "@media (max-width: 900px)": {
      display: "none"
    }
  };
});
var SessionPanelContent = (0,styled/* default */.ZP)("div")(function (_ref4) {
  var theme = _ref4.theme;
  return {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    alignSelf: "stretch",
    zIndex: 1
  };
});
;// CONCATENATED MODULE: ./src/pages/Audience/BookingManager/Steps/Registration/BookingRegistrationFlow.tsx


function BookingRegistrationFlow_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function BookingRegistrationFlow_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BookingRegistrationFlow_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BookingRegistrationFlow_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















var TOTAL_STEPS = 8;

var BookingRegistrationFlowInner = function BookingRegistrationFlowInner(_ref) {
  var email = _ref.email,
      firstName = _ref.firstName,
      selectedSession = _ref.selectedSession,
      showName = _ref.showName,
      showMinimumAge = _ref.showMinimumAge,
      onRegistrationComplete = _ref.onRegistrationComplete,
      onBackToSessionSelection = _ref.onBackToSessionSelection;

  var _useRegisterContext = (0,RegisterContext/* useRegisterContext */.$)(),
      setRegisterInfo = _useRegisterContext.setRegisterInfo;

  var _useState = (0,react.useState)(0),
      step = _useState[0],
      setStep = _useState[1];

  var _useState2 = (0,react.useState)({
    name: "",
    date: "",
    arrivalTime: "",
    approxFinishTime: "",
    location: null
  }),
      sessionDetails = _useState2[0],
      setSessionDetails = _useState2[1];

  (0,react.useEffect)(function () {
    setRegisterInfo(function (prev) {
      return BookingRegistrationFlow_objectSpread(BookingRegistrationFlow_objectSpread({}, prev), {}, {
        user: BookingRegistrationFlow_objectSpread(BookingRegistrationFlow_objectSpread({}, prev.user), {}, {
          email: email ? email : ""
        })
      });
    });
  }, []);
  (0,react.useEffect)(function () {
    if (selectedSession) {
      setSessionDetails((0,components/* generateSessionDetails */.G4)(selectedSession));
    }
  }, [selectedSession]);

  var nextStep = function nextStep() {
    if (step === TOTAL_STEPS - 1) {
      onRegistrationComplete();
    } else {
      setStep(step + 1);
    }
  };

  var prevStep = function prevStep() {
    if (step === 0) {
      onBackToSessionSelection();
      return;
    }

    setStep(step - 1);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* NavigationBar */.vx, {
      showHomeIconOnMobile: true,
      showMenu: false,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Stepper */.vF, {
        stepSize: TOTAL_STEPS,
        activeStepIndex: step
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(RegistrationFlowContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(RegistrationStepContainer, {
        children: [step === 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Register/* EmailVerification */.My, {
          onNextButtonClick: nextStep,
          onPrevButtonClick: prevStep
        }), step === 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(Password/* Password */.r, {
          onNextButtonClick: nextStep
        }), step === 2 && /*#__PURE__*/(0,jsx_runtime.jsx)(DateOfBirth/* DateOfBirth */.n, {
          onNextButtonClick: nextStep,
          onPrevButtonClick: prevStep
        }), step === 3 && /*#__PURE__*/(0,jsx_runtime.jsx)(Address/* Address */.k, {
          onNextButtonClick: nextStep,
          onPrevButtonClick: prevStep
        }), step === 4 && /*#__PURE__*/(0,jsx_runtime.jsx)(Accessibility/* Accessibility */.y, {
          onNextButtonClick: nextStep,
          onPrevButtonClick: prevStep
        }), step === 5 && /*#__PURE__*/(0,jsx_runtime.jsx)(Gender/* Gender */.Y, {
          onNextButtonClick: nextStep,
          onPrevButtonClick: prevStep
        }), step === 6 && /*#__PURE__*/(0,jsx_runtime.jsx)(PhoneNumber/* PhoneNumber */.B, {
          onNextButtonClick: nextStep,
          onPrevButtonClick: prevStep
        }), step === 7 && /*#__PURE__*/(0,jsx_runtime.jsx)(PhoneNumberVerification/* PhoneNumberVerification */.v, {
          onNextButtonClick: nextStep,
          onPrevButtonClick: prevStep
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SessionPanelContainer, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SessionPanelContent, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SessionDetails */.oW, {
            showName: showName,
            showMinimumAge: showMinimumAge,
            sessionDetails: sessionDetails
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* MeshGradient */.bL, {
          colour: "pink-purple-green",
          position: "bottom",
          size: "low",
          sx: {
            top: 0
          }
        })]
      })]
    })]
  });
};

var BookingRegistrationFlow = function BookingRegistrationFlow(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(RegisterContext/* RegisterProvider */.l, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BookingRegistrationFlowInner, BookingRegistrationFlow_objectSpread({}, props))
  });
};

/* harmony default export */ var Registration_BookingRegistrationFlow = (BookingRegistrationFlow);
;// CONCATENATED MODULE: ./src/pages/Audience/BookingManager/SuccessInvitedToTicket/SuccessInvitedToTicket.styles.ts


var SuccessInvitedToTicket_styles_SuccessContainer = (0,styled/* default */.ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    display: "flex",
    width: "400px",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.space._600,
    alignSelf: "strech",
    "@media (max-width: 600px)": {
      width: "100%"
    }
  };
});
var SuccessInvitedToTicket_styles_TitleContainer = (0,styled/* default */.ZP)("div")(function (_ref2) {
  var theme = _ref2.theme;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.space._500,
    alignSelf: "strech"
  };
});
var SuccessInvitedToTicket_styles_SuccessImage = (0,styled/* default */.ZP)("div")(function (_ref3) {
  var theme = _ref3.theme;
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "strech",
    width: theme.space._1150,
    height: theme.space._1050
  };
});
var SuccessInvitedToTicket_styles_Title = (0,styled/* default */.ZP)(Typography/* default */.Z)(function (_ref4) {
  var theme = _ref4.theme;
  return {
    color: theme.colors["neutral.50"],
    textAlign: "center",
    fontSize: theme.fontSizes["3xl"],
    fontFamily: theme.fonts["default"],
    fontWeight: theme.fontWeights.bold,
    lineHeight: theme.lineHeights.slim
  };
});
var SuccessInvitedToTicket_styles_SubTitle = (0,styled/* default */.ZP)(Typography/* default */.Z)(function (_ref5) {
  var theme = _ref5.theme;
  return {
    color: theme.colors["neutral.50"],
    textAlign: "center",
    fontSize: theme.fontSizes["2xl"],
    fontFamily: theme.fonts["default"],
    fontWeight: theme.fontWeights.bold,
    lineHeight: theme.lineHeights.slim
  };
});
var SuccessInvitedToTicket_styles_ContentContainer = (0,styled/* default */.ZP)("div")(function (_ref6) {
  var theme = _ref6.theme;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.space._400,
    alignSelf: "strech"
  };
});
var SuccessInvitedToTicket_styles_CTAContainer = (0,styled/* default */.ZP)("div")(function (_ref7) {
  var theme = _ref7.theme;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.space._400,
    alignSelf: "strech",
    marginTop: theme.space._400
  };
});
;// CONCATENATED MODULE: ./src/pages/Audience/BookingManager/SuccessInvitedToTicket/SuccessInvitedToTicket.tsx


function SuccessInvitedToTicket_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SuccessInvitedToTicket_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SuccessInvitedToTicket_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SuccessInvitedToTicket_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SuccessInvitedToTicket_Logo = function Logo(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", SuccessInvitedToTicket_objectSpread(SuccessInvitedToTicket_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M447.23 284.71c21.71 6.21 37.49 23.62 42.22 45.57q1.31 6.08 1.31 16.56-.02 44.58-.01 89.2c0 5.92-2.19 8.19-7.94 8.2l-12.03.02c-5.81 0-8.79-1.75-8.78-7.74q.02-45.08-.01-90.17-.01-8.28-1.38-12.52c-9.53-29.38-55.33-30.85-64.84-1.04q-1.31 4.12-1.3 11.55.1 45.61.02 91.2c-.01 5.5-1.65 8.65-7.4 8.69q-7.68.05-15.34 0c-4.46-.03-6-3.77-6-7.89V227.7c0-4.32 1.67-7.78 6.25-7.88q11.53-.26 16.01.01c5.25.31 6.47 4 6.48 8.83q.04 26.72 0 53.42c-.01 7.74 5.65 9.78 12.15 6.73 14.02-6.58 25.59-8.4 40.59-4.1zm378.75 18.13-5.05-75.62a.44.44 0 0 1 .44-.47h26.9a.44.44 0 0 1 .44.47l-5.35 75.62a.44.44 0 0 1-.44.41h-16.5a.44.44 0 0 1-.44-.41zM273.99 415.2c13.69 8.64 32.56-.23 33.75-17.08.39-5.58 1.95-8.04 7.62-8.09q6.4-.07 12.81-.02c10.81.08 8.92 9.29 7.07 17.21q-4.28 18.35-18.17 29.29c-20.83 16.4-50.34 13.9-68.44-5.24q-13.9-14.69-13.89-36.27.02-38.51.01-76.5a2.74 2.74 0 0 0-2.74-2.74q-15.49-.02-30.98-.01c-4.27.01-7.23-1.91-7.26-6.33q-.04-7.33-.02-14.66c.02-5.17 2.16-7.72 7.28-7.74q15.94-.04 31.24-.01a2.48 2.48 0 0 0 2.48-2.48q.01-24.15 0-49.03c0-5.33 3.48-7 8.46-7q6.23-.01 12.44.01c4.65.02 8.1 1.82 8.1 6.74v49.26a2.49 2.49 0 0 0 2.49 2.49h51.26c4.38 0 6.22 3.48 6.23 7.64q.02 6.76.03 13.5c.01 4.47-1.69 7.61-6.42 7.6q-25.53 0-50.77.02a2.82 2.81 0 0 0-2.82 2.81v76.18c.01 8.87 2.83 15.78 10.24 20.45zm457.47-129.04.55.46q.47.38 1.07.38 24.56 0 49.1.01c6.13 0 8.73 1.87 8.79 8 .08 6.91 1.37 16.82-2.69 19.61q-1.66 1.13-5.31 1.13H733.7a2.96 2.96 0 0 0-2.96 2.96q.03 37.06-.01 74.74 0 6.72 1.31 10.42c5.85 16.45 26.76 19.89 37.83 6.31q4.44-5.45 4.93-14.17c.29-5.02 4.58-5.98 9.07-6q6.69-.03 13.38 0c4.34.02 6.27 3.52 6.27 7.64-.01 15.79-8.46 30.97-20.77 39.9-29.5 21.43-70.79 6.01-79.39-29.08q-1.35-5.52-1.36-15.54v-74.02a3.15 3.15 0 0 0-3.14-3.15q-15.87-.04-32.11.01c-4.33.01-5.94-3.6-5.98-7.62q-.06-6.55-.01-13.11c.04-4.4 1.79-8.06 6.49-8.05q16.26.02 31.88 0a2.85 2.85 0 0 0 2.84-2.85q.03-24.3.04-48.24c0-4.81 2.13-7.38 6.92-7.39q7-.02 13.99-.01c5.43 0 7.81 2.32 7.82 7.59q.02 24.34 0 48.55a1.97 1.96 19.7 0 0 .72 1.52zm-118.21 62.16c5.09.04 3.5-8.85 3.52-12.07q.08-20.15-18.83-25.14c-9.67-2.56-26.42-1.63-34.46 5.05q-5.26 4.38-5.49 12.59-.12 4.13-5 4.3-6.65.22-13.3.19c-5.1-.03-9.47.41-9.88-5.48q-.63-9.15 4.3-18.9c7.77-15.36 27.35-24.06 44.01-26.03 27.61-3.28 59.28 6.97 66.02 37.51q1.29 5.86 1.32 19.92.09 47.8.02 95.61c-.01 5.39-1.83 8.29-7.35 8.36q-7.39.1-10.38.01c-6.37-.2-5.89-12.33-13.27-8.07-8.8 5.08-15.36 9.39-26.48 10.67-15.23 1.75-32.09-.94-44.71-9.4-26.55-17.78-28.2-60.42-2.06-79.28q8.72-6.29 19.61-8.58 5.86-1.23 19.91-1.3 16.25-.09 32.5.04zm-19.37 71.34q19.83-3.46 24.27-21.47c1.49-6.07 1.23-14.18 1.06-20.9a2.85 2.84 89.3 0 0-2.84-2.78q-20.92-.04-41.97.02c-10.5.02-19.79 4.17-22.33 15.24-2.82 12.3 1.81 24.93 14.44 29.17 8.27 2.78 19.14 2.15 27.37.72zm340.75-136.78c24.27 2.93 46.98 19.2 47.65 45.53.14 5.39-2.03 8.03-7.38 8.07q-6.29.05-12.58.02c-4.38-.03-8.5-1.18-8.78-6q-.37-6.63-2.79-10.34-4.46-6.82-12.39-8.99c-12.68-3.46-33.42-2.63-39.44 12.07q-3.6 8.77 4.14 15.18c5.09 4.2 13.7 5.93 20.97 7.15 30.66 5.11 65.02 12.39 64.33 52.05-.91 52.21-72.46 61.2-105.63 37.21-13.4-9.69-20.66-27-19.73-43.09.25-4.37 3.77-5.72 7.85-5.73q6.47-.03 12.95.01c4.21.02 8 1.7 7.99 6.23-.02 25.31 22.62 28.75 42.21 27.28 13.97-1.05 26.73-8.39 25.59-24.29-2.21-30.83-83.92-9.29-90.88-60.74-5.08-37.49 35.16-55.34 65.92-51.62zM460.57 605.39c-9.44-29.3-55.17-30.67-64.82-.95q-1.28 3.95-1.27 10.75.08 47.29.01 94.56c-.01 4.36-3.82 6-7.88 6q-6.58-.01-13.13.01c-5.11.02-7.73-1.85-7.73-7.02q0-104.85.01-209.71c0-3.78 1.73-7.47 5.73-7.5q7.45-.06 14.89-.02c5.44.04 8.09 2.19 8.1 7.61q.06 27.61.01 55.22c-.01 6.44 5.51 9.26 11.28 6.59 9.63-4.45 17.25-7.42 27.48-6.86 27.38 1.48 50.08 20.27 56.07 47.07q1.4 6.25 1.41 18.33.05 44.5 0 89c0 4.21-1.92 7.26-6.31 7.27l-14.71.02c-4.98.01-7.7-1.98-7.7-7.01q-.02-44.49-.01-88.98.01-9.91-1.43-14.38z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      x: "-16",
      y: "-16.13",
      transform: "rotate(.115 -290264.664 564080.533)",
      width: "32",
      height: "32.26",
      rx: "5.22"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M1266.16 608.54q.49.97 1.4.71.36-.11.82-.52 26.39-24.28 52.76-48.59c2.35-2.17 4.63-2.86 8.03-2.87q8.92-.03 17.84-.03c4.08.01 6.69 4.69 5.47 8.37q-.51 1.55-2.99 3.87-32.02 30.08-63.42 59.72-3.7 3.49-.03 7.02 35.98 34.51 72.31 69.43c2.89 2.78 1.09 7.58-2.01 9.27q-1.55.84-5.32.84-8.98 0-17.97-.03c-3.92-.02-6.55-1.26-9.21-3.82q-26.86-25.89-53.65-51.86-1.22-1.19-2.36-1.83a1.23 1.23 0 0 0-1.83 1.07q-.01 24.84 0 49.96c0 4.53-3.04 6.45-7.42 6.48q-6.99.04-13.98.02c-4.53-.01-7.34-2.04-7.34-6.65q-.01-104.57-.01-209.14c0-5.87 1.8-8.41 7.7-8.44q7.27-.03 14.56-.04c4.85 0 6.48 3.89 6.48 8.36q.02 53.93.01 108a1.62 1.59-58.5 0 0 .16.7zM234.72 556.31q.1-24.09.01-48.81-.02-7.1 7.26-7.3 6.45-.17 12.89-.18c6.23 0 8.84 2.1 8.85 8.29q.04 23.85.01 47.66a2.79 2.79 0 0 0 2.79 2.79q24.8-.02 49.86.01c4.51 0 7.36 2.01 7.36 6.62q-.01 6.87.01 13.71c.02 5.64-1.65 8.38-7.42 8.39q-25.16.03-50.1.01a2.48 2.48 0 0 0-2.49 2.48q0 37.04-.01 74.7 0 7.52 1.23 10.99c5.71 16.07 26.55 19.59 37.46 6.77q4.97-5.84 5.35-14.69c.2-4.65 3.87-5.99 8.16-5.99l14.31-.02c5.17-.01 6.43 4.38 6.23 8.9-1.06 23.13-17.98 42.57-40.23 47.35-32.47 6.96-61.51-18.38-61.5-50.99q.01-38.87 0-77.01a2.48 2.48 0 0 0-2.48-2.48q-16.02-.03-32.52 0c-4.68.01-6-4.01-6.01-8.22q-.01-6.54.03-13.08c.04-5.11 2.23-7.47 7.23-7.46q15.75.02 31.28-.01a2.44 2.44 0 0 0 2.44-2.43zm658.32 129.73q-6.53 16.64-20.92 25.46c-29.42 18.02-68.14 2-75.99-31.29q-1.39-5.91-1.39-17.53.02-36.2.01-72.23a2.95 2.95 0 0 0-2.95-2.95q-14.66-.01-29.91 0c-5.54 0-8.37-1.68-8.38-7.39q-.02-6.65 0-13.28c.01-5.42 1.84-8.07 7.33-8.07q15.79-.01 30.96-.01a2.96 2.95-89.9 0 0 2.95-2.95q.01-23.74-.01-47.67c0-5.66 2.12-8.03 7.66-8.1q6.11-.07 12.23-.02c6.35.06 8.87 1.97 8.87 8.31v47.73a2.7 2.7 0 0 0 2.7 2.7q24.5.01 49.41 0c5.53 0 8.05 2.18 8.11 7.62q.08 6.34.01 12.68c-.05 5.64-1.91 8.44-7.66 8.44q-25.03.03-49.87.01a2.69 2.69 0 0 0-2.7 2.69v73.52q0 8.52 1.44 12.37c4.01 10.7 15.87 16.66 26.95 13.18q12.06-3.78 15.27-16.79c.98-3.95-.56-7.44 3.66-9.87 3.08-1.78 13.09-.86 16.96-.85q3.76 0 5.32.76c6.16 2.97 2.06 18.12-.06 23.53zm704.77-96.02a1.74 1.68 53.5 0 0-.06.45q-.01 36.62.01 73.3 0 8.43 1.45 12.26c4.13 10.9 16.3 16.86 27.54 13.07q11.22-3.79 14.67-16.22c1.07-3.87-.64-8.2 4.04-10.48q1.26-.61 3.7-.63 6.66-.05 13.33-.02c9.38.05 8.75 6.71 7.67 13.8-2.04 13.36-9.14 25.19-19.68 33.16-29.44 22.24-71.56 6.77-80.11-28.84q-1.36-5.71-1.37-16.35-.01-36.63 0-73.13a2.88 2.87-90 0 0-2.87-2.88q-14.74-.03-29.99 0c-5.43.01-8.32-1.85-8.37-7.4q-.06-7.68 0-15.36c.04-4.57 4.02-5.99 8.19-5.99q15.35-.01 30.16-.01a2.87 2.87 0 0 0 2.87-2.87q.03-23.29 0-47.12c-.01-5.87 1.75-8.68 7.74-8.73q7.26-.07 14.52-.02c5.08.04 6.49 4.01 6.5 8.62q.01 23.57 0 47.21a2.91 2.91 0 0 0 2.91 2.92q24.53-.02 49.65.01c4.89 0 7.57 2.04 7.65 6.94q.11 7.13 0 14.25c-.07 4.64-2.18 7.51-6.9 7.52q-24.82.05-49.64.01c-1.89 0-3.13.58-3.61 2.53zm-950.72 93.05c-6.26 16.07-19.81 27.49-36.13 32.53-36.66 11.34-75.66-5.49-85.56-44.34q-1.71-6.71-2.27-17.64-.94-18.36.15-37.62c2.6-45.81 42.98-70.96 86.18-59.23 23.5 6.37 38.1 24.16 41.65 47.84 1.46 9.77.95 22.47.87 33.49-.03 4.61-1.84 7.64-6.66 7.64q-45.03.02-90.07.01-3.27 0-3.33 3.24c-.37 20.37 8.11 37.85 30.07 40.9q13.47 1.87 24.44-3.48 10.78-5.27 15.18-17.55c1-2.8 3.96-3.81 6.96-3.83q7.44-.05 14.89-.03c3.75.01 6.95.98 6.78 5.25q-.22 5.31-3.15 12.82zm-91.4-62.69 65.76-.22a3.15 3.15 0 0 0 3.13-3.17v-1.02a34.57 33.33-.2 0 0-34.69-33.2l-2.92.01a34.57 33.33-.2 0 0-34.45 33.45v1.02a3.15 3.15 0 0 0 3.17 3.13zm556.25-62.46c37.25-12.69 84.39 5.95 84.89 50.31.06 5.34-3.67 6.3-8.35 6.28q-7.38-.02-14.71-.13c-4.83-.07-5.52-2.66-5.86-7.08-1.36-17.38-18.68-24.96-33.98-24.54-13.55.37-25.39 7.43-30.55 20.17q-2.35 5.8-2.96 17-.88 15.93-.07 31.87.66 12.85 3.25 19.02c6.21 14.81 22.04 21.12 37.78 19.15 13.26-1.66 25.63-10.51 26.32-25 .19-3.81 1.32-6.19 5.31-6.39q4.66-.22 15.16-.07c6.07.09 8.81 2.14 8.58 8.29-1.46 38.07-38.71 56.69-72.75 51.34-25.65-4.03-43.94-21.73-50.1-46.9q-1.62-6.6-2.27-18.12-1.28-22.5.64-42.37c2.24-23.13 17.33-45.22 39.67-52.83zm333.93 160.91c-37.6 2.4-67.62-22.04-70.12-60.09q-1.56-23.64-.17-44.49c1.98-29.65 22.3-53.91 51.92-59.13 40.03-7.05 75.8 15.67 76.63 58.63q.4 20.76.05 26.5c-.26 4.23-4.09 5.5-8 5.5H1407c-2.13 0-2.98 1.8-2.98 3.79q.01 9.43 2.03 15.98 7.34 23.88 32.71 24.9c13.32.54 27.61-5.04 33.56-17.68 2.29-4.86 2.24-7.7 8.87-7.73q7.42-.02 14.83-.01c4.83 0 7.03 2.09 6.24 6.89-4.72 28.63-28.73 45.18-56.39 46.94zm-38-98.46 65.86-.23a3.09 3.09 0 0 0 3.07-3.1v-1.13a34.56 33.26-.2 0 0-34.68-33.13l-2.92.01a34.56 33.26-.2 0 0-34.44 33.38v1.13a3.09 3.09 0 0 0 3.11 3.07zm-408.78 66.78c.71 1.2 1.87 1.6 3.29 1.6h38.05c5.45 0 7.99 1.87 8.04 7.33q.06 5.88.02 11.77c-.03 4.47-1.58 7.89-6.43 7.89q-57.9.02-115.79.01c-5.21 0-7.93-1.73-7.99-7.06q-.07-6.96-.03-13.95c.03-4.24 3.6-5.96 7.6-5.97q20.36-.04 40.61-.01a2.79 2.79 0 0 0 2.79-2.79v-98.95a2.78 2.77.1 0 0-2.77-2.77q-18.46-.01-37.01 0c-4.92.01-7.88-1.61-7.94-6.75q-.08-6.48-.01-12.96c.04-4.22 1.89-7.28 6.32-7.28q31.54-.02 63.07-.01c5.52.01 7.83 2.22 7.83 7.6q.02 60.56.01 121.05a2.48 2.46 30 0 0 .34 1.25zm63.17 218.78c-55.41-1.12-97.06-31.32-125.13-77.23q-3.84-6.27-4.39-9.94c-2-13.41 14.1-22.54 24.9-14.76q2.01 1.45 5.5 6.2c23.85 32.44 53.2 54.88 94.99 56.85q6.81.33 13.62.15c42.24-1.12 73.53-22.77 97.48-55.96q4.18-5.79 6.32-7.32c10.73-7.68 26.53 1.24 24.84 14.64q-.47 3.7-3.93 9.4c-13.22 21.74-30.4 41.8-51.76 55.69-24.98 16.24-52.67 22.89-82.44 22.28z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      style: {
        fontWeight: "700",
        fontSize: "122.5px",
        fontFamily: "Monospace",
        InkscapeFontSpecification: "'Monospace Bold'",
        fill: "#fff",
        strokeWidth: "13.125"
      },
      d: "M1537.917 842.137q0-10.467 3.47-21.174 2.571-7.895 7.954-17.585 3.888-6.939 5.743-8.494 1.854-1.615 4.127-1.615 2.632 0 4.426 1.794 1.794 1.795 1.794 4.307 0 1.735-1.435 4.127-6.46 10.587-9.45 19.859-2.932 9.27-2.932 18.781 0 9.57 2.931 18.842 2.991 9.271 9.451 19.858 1.435 2.333 1.435 4.127 0 2.513-1.794 4.307-1.794 1.795-4.426 1.795-2.213 0-3.888-1.436-2.393-2.094-6.34-9.39-5.683-10.588-7.776-17.467-3.29-10.527-3.29-20.636zm62.446-47.791v27.514q4.486-2.93 9.092-4.366 4.665-1.496 9.39-1.496 12.741 0 21.594 8.793 8.852 8.793 8.852 21.234 0 11.903-8.434 19.918-8.433 7.956-22.25 7.956-4.905 0-9.451-1.256t-8.793-3.709v2.99h-14.355q-4.427 0-6.34-1.674-1.855-1.734-1.855-4.486 0-2.692 1.914-4.366 1.914-1.735 6.28-1.735h2.094v-53.055h-2.093q-4.427 0-6.34-1.675-1.855-1.735-1.855-4.486 0-2.692 1.854-4.367 1.914-1.734 6.34-1.734zm36.666 52.038q0-7.596-5.323-12.86-5.324-5.264-13.04-5.264-7.656 0-12.98 5.264-5.323 5.264-5.323 12.68 0 6.76 4.785 11.126 4.785 4.307 13.518 4.307t13.518-4.307q4.845-4.366 4.845-10.946zm83.083 4.606h-50.304q1.914 4.785 6.759 7.716 4.905 2.93 13.219 2.93 6.819 0 18.123-2.93 4.666-1.196 6.46-1.196 2.453 0 4.128 1.734 1.674 1.735 1.674 4.367 0 2.392-1.794 4.067-2.393 2.213-11.664 4.247-9.271 1.974-17.825 1.974-14.714 0-23.566-8.314-8.793-8.315-8.793-20.457 0-12.92 9.51-20.995 9.57-8.135 22.012-8.135 7.477 0 13.698 2.632 6.28 2.632 9.33 5.683 4.307 4.426 7.119 10.946 1.914 4.546 1.914 10.527zm-13.578-12.262q-2.812-5.264-7.357-7.836-4.546-2.632-10.827-2.632-6.22 0-10.766 2.632-4.546 2.572-7.417 7.836zm53.294-8.853v24.584q0 3.948 1.615 5.204 2.513 1.974 8.973 1.974 9.39 0 17.346-4.008 3.05-1.555 4.785-1.555 2.393 0 4.127 1.795 1.795 1.794 1.795 4.366 0 2.393-1.914 4.127-2.931 2.811-11.604 5.204-8.614 2.333-14.535 2.333-11.425 0-17.167-4.905-5.683-4.965-5.683-12.142v-26.977h-4.426q-4.426 0-6.34-1.674-1.854-1.735-1.854-4.487 0-2.691 1.854-4.366 1.914-1.735 6.34-1.735h4.426v-11.065q0-4.427 1.675-6.28 1.735-1.915 4.486-1.915 2.692 0 4.367 1.914 1.734 1.854 1.734 6.28v11.066h22.67q4.426 0 6.28 1.735 1.915 1.675 1.915 4.426 0 2.692-1.914 4.427-1.855 1.674-6.28 1.674zm87.569 42.05v-2.871q-4.606 2.452-10.169 3.649-5.562 1.256-10.108 1.256-9.87 0-16.03-5.204-6.161-5.264-6.161-11.604 0-7.716 7.835-14.296 7.896-6.64 21.773-6.64 5.562 0 12.86 1.197v-2.93q0-2.752-2.393-4.487-2.332-1.735-8.972-1.735-5.443 0-14.116 2.154-3.23.777-5.024.777-2.453 0-4.187-1.734-1.675-1.795-1.675-4.546 0-1.555.598-2.692.598-1.136 1.675-1.794 1.076-.718 4.486-1.675 4.546-1.256 9.27-1.974 4.726-.778 8.554-.778 11.425 0 17.706 4.965 6.34 4.905 6.34 13.458v25.242h2.093q4.427 0 6.28 1.735 1.915 1.674 1.915 4.426 0 2.692-1.914 4.426-1.854 1.675-6.28 1.675zm0-21.952q-7.357-1.436-13.578-1.436-7.477 0-12.86 3.65-3.35 2.332-3.35 4.725 0 1.734 1.615 2.81 2.991 1.975 8.195 1.975 4.426 0 9.989-1.735 5.622-1.735 9.989-4.725zm67.71-7.836q0 10.468-3.47 21.234-2.571 7.896-7.955 17.526-3.888 6.939-5.742 8.554-1.854 1.615-4.127 1.615-2.632 0-4.426-1.795-1.795-1.794-1.795-4.307 0-1.794 1.436-4.127 6.46-10.587 9.39-19.858 2.991-9.271 2.991-18.842 0-9.51-2.99-18.781-2.931-9.272-9.391-19.859-1.436-2.392-1.436-4.127 0-2.512 1.795-4.307 1.794-1.794 4.426-1.794 2.213 0 3.888 1.435 2.392 2.034 6.34 9.391 5.682 10.588 7.776 17.406 3.29 10.588 3.29 20.636z"
    })]
  }));
};

SuccessInvitedToTicket_Logo.defaultProps = {
  width: "150",
  height: "80",
  viewBox: "0 0 1920 1050",
  fill: "#FCFCFC",
  xmlns: "http://www.w3.org/2000/svg"
};



/**
 * "emailOffer" is the standard invitation, valid for hours or days.
 * "lastMinOffer" is the consolidated flow's last-min path: applying inside the last-min
 * phase can hand out a seat immediately, by SMS, with minutes on the clock — so the copy
 * cannot talk about inboxes and cannot imply there is time to spare.
 */





var SuccessInvitedToTicket_Success = function Success(_ref) {
  var firstName = _ref.firstName,
      bookingInterestId = _ref.bookingInterestId,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "emailOffer" : _ref$variant;
  var router = (0,next_router.useRouter)();
  var isLastMin = variant === "lastMinOffer";
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SuccessInvitedToTicket_styles_SuccessContainer, {
    "data-cy": "booking-interest-registration-success",
    "data-cy-variant": variant,
    "data-bookinginterest-id": bookingInterestId,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SuccessInvitedToTicket_styles_TitleContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SuccessInvitedToTicket_styles_SuccessImage, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessInvitedToTicket_Logo, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SuccessInvitedToTicket_styles_Title, {
        children: ["Congratulations ", firstName, "!"]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SuccessInvitedToTicket_styles_ContentContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SuccessInvitedToTicket_styles_SubTitle, {
        children: isLastMin ? "A last minute seat just opened up for you!" : "You’ve already been Invited to receive Tickets!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* List */.aV, {
        elements: isLastMin ? [/*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: "This is a last minute offer, so the clock is already running - confirm now, before the seat goes to the next person in the queue."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: "We have also texted you the link. Confirming is one step: it accepts the ticket and checks you in at the same time."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: ["You can always find this booking in your profile under", /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/profile?tab=tickets",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Success_styles_StyledBlueSpan, {
              children: " Applications & Tickets "
            })
          }), "."]
        })] : [/*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: "The countdown has begun! Accept your ticket (and any dependant\u2019s tickets) now before time runs out."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: "Any guests in your booking will have a ticket offer too! Shoot them a text and ask them to check their inbox (and SPAM/Promotions folder) pronto."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: ["If your guests still can\u2019t see the email, check and change their email address in your profile under", /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/profile?tab=tickets",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Success_styles_StyledBlueSpan, {
              children: " Applications & Tickets "
            })
          }), " - Manage My Booking."]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessInvitedToTicket_styles_CTAContainer, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
        "data-cy": "accept-ticket-now-button",
        onClick: function onClick() {
          return router.push('/profile');
        },
        children: isLastMin ? "CONFIRM YOUR SEAT NOW!" : "ACCEPT YOUR TICKET NOW!"
      })
    })]
  });
};

/* harmony default export */ var SuccessInvitedToTicket = ((0,next_router.withRouter)(SuccessInvitedToTicket_Success));
// EXTERNAL MODULE: ./src/contexts/AuthContext.tsx
var AuthContext = __webpack_require__(82030);
;// CONCATENATED MODULE: ./src/pages/Audience/BookingManager/SuccessInvitedToPriorityTicket copy/SuccessInvitedToPriorityTicket.styles.ts


var SuccessInvitedToPriorityTicket_styles_SuccessContainer = (0,styled/* default */.ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    display: "flex",
    width: "400px",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.space._600,
    alignSelf: "strech",
    "@media (max-width: 600px)": {
      width: "100%"
    }
  };
});
var SuccessInvitedToPriorityTicket_styles_TitleContainer = (0,styled/* default */.ZP)("div")(function (_ref2) {
  var theme = _ref2.theme;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.space._500,
    alignSelf: "strech"
  };
});
var SuccessInvitedToPriorityTicket_styles_SuccessImage = (0,styled/* default */.ZP)("div")(function (_ref3) {
  var theme = _ref3.theme;
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "center",
    position: "relative",
    width: theme.space._1250,
    height: theme.space._1100
  };
});
var SuccessInvitedToPriorityTicket_styles_Title = (0,styled/* default */.ZP)(Typography/* default */.Z)(function (_ref4) {
  var theme = _ref4.theme;
  return {
    color: theme.colors["neutral.50"],
    textAlign: "center",
    fontSize: theme.fontSizes["3xl"],
    fontFamily: theme.fonts["default"],
    fontWeight: theme.fontWeights.bold,
    lineHeight: theme.lineHeights.slim
  };
});
var SuccessInvitedToPriorityTicket_styles_SubTitle = (0,styled/* default */.ZP)(Typography/* default */.Z)(function (_ref5) {
  var theme = _ref5.theme;
  return {
    color: theme.colors["neutral.50"],
    textAlign: "center",
    fontSize: theme.fontSizes["3xl"],
    fontFamily: theme.fonts["default"],
    fontWeight: theme.fontWeights.bold,
    lineHeight: theme.lineHeights.slim
  };
});
var SuccessInvitedToPriorityTicket_styles_ContentContainer = (0,styled/* default */.ZP)("div")(function (_ref6) {
  var theme = _ref6.theme;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.space._600,
    alignSelf: "strech"
  };
});
var SuccessInvitedToPriorityTicket_styles_CTAContainer = (0,styled/* default */.ZP)("div")(function (_ref7) {
  var theme = _ref7.theme;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.space._400,
    alignSelf: "strech",
    marginTop: theme.space._400
  };
});
;// CONCATENATED MODULE: ./src/pages/Audience/BookingManager/SuccessPriority/SuccessPriority.styles.ts


var SuccessPriority_styles_SuccessContainer = (0,styled/* default */.ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    display: "flex",
    width: "400px",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.space._600,
    alignSelf: "strech",
    "@media (max-width: 600px)": {
      width: "100%"
    }
  };
});
var SuccessPriority_styles_StyledBlueSpan = (0,styled/* default */.ZP)("span")(function (_ref2) {
  var theme = _ref2.theme;
  return {
    color: theme.colors["blue.400"]
  };
});
var SuccessPriority_styles_TitleContainer = (0,styled/* default */.ZP)("div")(function (_ref3) {
  var theme = _ref3.theme;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.space._500,
    alignSelf: "strech"
  };
});
var SuccessPriority_styles_ImageContainer = (0,styled/* default */.ZP)("div")(function (_ref4) {
  var theme = _ref4.theme;
  return {
    display: "flex",
    position: "relative",
    alignItems: "center",
    alignSelf: "strech",
    aspectRatio: 2.14,
    width: "100%",
    maxWidth: "338px",
    height: "auto"
  };
});
var SuccessPriority_styles_SuccessImage = (0,styled/* default */.ZP)("div")(function (_ref5) {
  var theme = _ref5.theme;
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "center",
    position: "relative",
    width: theme.space._1250,
    height: theme.space._1100
  };
});
var SuccessPriority_styles_Title = (0,styled/* default */.ZP)(Typography/* default */.Z)(function (_ref6) {
  var theme = _ref6.theme;
  return {
    color: theme.colors["neutral.50"],
    textAlign: "center",
    fontSize: theme.fontSizes["3xl"],
    fontFamily: theme.fonts["default"],
    fontWeight: theme.fontWeights.bold,
    lineHeight: theme.lineHeights.slim
  };
});
var ContentTitle = (0,styled/* default */.ZP)(Typography/* default */.Z)(function (_ref7) {
  var theme = _ref7.theme;
  return {
    color: theme.colors["neutral.50"],
    textAlign: "center",
    fontSize: theme.fontSizes["2xl"],
    fontFamily: theme.fonts["default"],
    fontWeight: theme.fontWeights.bold,
    lineHeight: theme.lineHeights.slim
  };
});
var SuccessPriority_styles_SubTitle = (0,styled/* default */.ZP)(Typography/* default */.Z)(function (_ref8) {
  var theme = _ref8.theme;
  return {
    color: theme.colors["neutral.500"],
    textAlign: "center",
    fontSize: theme.fontSizes["md"],
    fontFamily: theme.fonts["default"],
    fontWeight: theme.fontWeights.regular,
    lineHeight: theme.lineHeights.tall
  };
});
var SuccessPriority_styles_EndingPhrase = (0,styled/* default */.ZP)(Typography/* default */.Z)(function (_ref9) {
  var theme = _ref9.theme;
  return {
    color: theme.colors["neutral.500"],
    fontFamily: theme.fonts["default"],
    fontSize: theme.fontSizes.md,
    fontWeight: theme.fontWeights.regular,
    lineHeight: theme.lineHeights.base
  };
});
var SuccessPriority_styles_ContentContainer = (0,styled/* default */.ZP)("div")(function (_ref10) {
  var theme = _ref10.theme;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.space._400,
    alignSelf: "strech"
  };
});
var SuccessPriority_styles_CTAContainer = (0,styled/* default */.ZP)("div")(function (_ref11) {
  var theme = _ref11.theme;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.space._600,
    alignSelf: "strech"
  };
});
;// CONCATENATED MODULE: ./src/pages/Audience/BookingManager/SuccessInvitedToPriorityTicket copy/SuccessInvitedToPriorityTicket.tsx











var SuccessPriority = function SuccessPriority(_ref) {
  var firstName = _ref.firstName,
      bookingInterestId = _ref.bookingInterestId,
      ticketHolders = _ref.ticketHolders,
      session = _ref.session,
      showName = _ref.showName;
  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SuccessInvitedToPriorityTicket_styles_SuccessContainer, {
    "data-cy": "booking-interest-registration-success",
    "data-bookinginterest-id": bookingInterestId,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SuccessInvitedToPriorityTicket_styles_TitleContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SuccessInvitedToPriorityTicket_styles_SuccessImage, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          fill: true,
          src: "/images/email/gifs/flock-happy.gif",
          alt: "TTT Happy Bird Animation"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SuccessInvitedToPriorityTicket_styles_Title, {
        children: ["Congratulations ", firstName, "!"]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SuccessInvitedToPriorityTicket_styles_ContentContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SuccessInvitedToPriorityTicket_styles_SubTitle, {
        children: "We just emailed you your priority ticket!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* TicketSummaryPanel */.cY, {
        ticketHolders: ticketHolders,
        session: session,
        showName: showName
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* List */.aV, {
        elements: [/*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: "The countdown has begun! Accept your ticket (and any dependant\u2019s tickets) now before time runs out."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: "Any guests in your booking will have a ticket offer too! Shoot them a text and ask them to check their inbox (and SPAM/Promotions folder) pronto."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: ["If your guests still can\u2019t see the email, check and change their email address in your profile under", /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/profile?tab=tickets",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessPriority_styles_StyledBlueSpan, {
              children: " Applications & Tickets "
            })
          }), " - Manage My Booking."]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessInvitedToPriorityTicket_styles_CTAContainer, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
        "data-cy": "accept-ticket-now-button",
        onClick: function onClick() {
          return router.push('/profile');
        },
        children: " ACCEPT YOUR TICKET NOW! "
      })
    })]
  });
};

/* harmony default export */ var SuccessInvitedToPriorityTicket = ((0,next_router.withRouter)(SuccessPriority));
;// CONCATENATED MODULE: ./src/pages/Audience/BookingManager/SuccessPriority/SuccessPriority.content.tsx






var SuccessPriority_content_ListContent = {
  Line1: /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: ["You can now find and", /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Tooltip */.u, {
      tooltipName: "manageBooking",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessPriority_styles_StyledBlueSpan, {
        children: " update "
      })
    }), "this ticket request in your profile under", /*#__PURE__*/(0,jsx_runtime.jsxs)((link_default()), {
      href: "/profile?tab=tickets",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SuccessPriority_styles_StyledBlueSpan, {
        children: " Applications & Tickets "
      }), "."]
    })]
  }),
  Line2: /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: ["Ticket offers are usually sent out", /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Tooltip */.u, {
      tooltipName: "lastMinuteTickets",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessPriority_styles_StyledBlueSpan, {
        children: " 1 to 2 weeks "
      })
    }), "before the show date."]
  }),
  Line3: /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: ["You and your guests will have a", /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Tooltip */.u, {
      tooltipName: "ticketOfferExpiration",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessPriority_styles_StyledBlueSpan, {
        children: " limited time "
      })
    }), "to accept."]
  })
};
var SuccessPriority_content_ListArray = [SuccessPriority_content_ListContent.Line1, SuccessPriority_content_ListContent.Line2, SuccessPriority_content_ListContent.Line3];
;// CONCATENATED MODULE: ./src/pages/Audience/BookingManager/SuccessPriority/SuccessPriority.tsx









var SuccessPriority_Success = function Success(_ref) {
  var firstName = _ref.firstName,
      bookingInterestId = _ref.bookingInterestId,
      accessibilityPending = _ref.accessibilityPending;
  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SuccessPriority_styles_SuccessContainer, {
    "data-cy": "booking-interest-registration-success",
    "data-bookinginterest-id": bookingInterestId,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SuccessPriority_styles_TitleContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SuccessPriority_styles_SuccessImage, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          fill: true,
          src: accessibilityPending ? "/images/email/gifs/flock-happy.gif" : "/images/email/gifs/flock-sad.gif",
          alt: "TTT Bird Animation"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessPriority_styles_Title, {
        children: accessibilityPending ? "We’ve received your priority ticket request!" : "😨 Oh No! Priority tickets ran out as you were applying..!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessPriority_styles_SubTitle, {
        children: accessibilityPending ? "Due to your accessibility requirements, we need to check if we can accommodate you properly. We’ll get back to you as soon as possible!" : "We’re so sorry 🙏. This can happen when demand is really high, they go like hotcakes on a first-come, first-served basis!"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SuccessPriority_styles_ContentContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ContentTitle, {
        children: accessibilityPending ? "What happens next?" : "But Don’t Worry!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessPriority_styles_SubTitle, {
        children: accessibilityPending ? "We’re reviewing your request and will be in touch shortly. In the meantime:" : "We’ve registered you for a regular ticket instead. See what happens now below:"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessPriority_styles_ImageContainer, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: "/images/email/progress-red-carpet-application.png",
          fill: true,
          alt: "Progress bar - applied for tickets step"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* List */.aV, {
        elements: SuccessPriority_content_ListArray
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SuccessPriority_styles_CTAContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SuccessPriority_styles_EndingPhrase, {
        children: "Want to increase your chances of getting tickets?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
        onClick: function onClick() {
          return router.reload();
        },
        "data-cy": "book-another-ticket-button",
        children: " Apply for another Session "
      })]
    })]
  });
};

/* harmony default export */ var SuccessPriority_SuccessPriority = ((0,next_router.withRouter)(SuccessPriority_Success));
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useQuery.js + 6 modules
var useQuery = __webpack_require__(10777);
// EXTERNAL MODULE: ./src/utils/dates.tsx
var dates = __webpack_require__(15443);
// EXTERNAL MODULE: ./src/services/AllocationsService.tsx
var AllocationsService = __webpack_require__(72116);
// EXTERNAL MODULE: ./src/utils/sessionUtils.ts
var sessionUtils = __webpack_require__(65021);
;// CONCATENATED MODULE: ./src/pages/Audience/BookingManager/BookingManager.tsx



function BookingManager_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function BookingManager_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BookingManager_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BookingManager_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




























var BookingManager = function BookingManager(_ref) {
  var show = _ref.show,
      router = _ref.router,
      promoCode = _ref.promoCode,
      priority = _ref.priority;

  var _useAuthContext = (0,AuthContext/* useAuthContext */.E)(),
      user = _useAuthContext.user;

  var _useState = (0,react.useState)(false),
      submitting = _useState[0],
      setSubmitting = _useState[1];

  var _useState2 = (0,react.useState)(),
      session = _useState2[0],
      setSession = _useState2[1];

  var _useState3 = (0,react.useState)(0),
      step = _useState3[0],
      setStep = _useState3[1];

  var _useState4 = (0,react.useState)(null),
      bookingInterestId = _useState4[0],
      setBookingInterestId = _useState4[1];

  var _useState5 = (0,react.useState)(),
      newBookingInterestStatus = _useState5[0],
      setNewBookingInterestStatus = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      bookingInterestError = _useState6[0],
      setBookingInterestError = _useState6[1];

  var _useState7 = (0,react.useState)(""),
      errorMessage = _useState7[0],
      setErrorMessage = _useState7[1];

  var _useState8 = (0,react.useState)(false),
      continueWithNonPriority = _useState8[0],
      setContinueWithNonPriority = _useState8[1];

  var _useState9 = (0,react.useState)(false),
      resolvedIsPriority = _useState9[0],
      setResolvedIsPriority = _useState9[1];

  var _useState10 = (0,react.useState)(false),
      registrationMode = _useState10[0],
      setRegistrationMode = _useState10[1];

  var _useState11 = (0,react.useState)(""),
      registrationEmail = _useState11[0],
      setRegistrationEmail = _useState11[1];

  var _useState12 = (0,react.useState)(""),
      registrationFirstName = _useState12[0],
      setRegistrationFirstName = _useState12[1];

  var _useState13 = (0,react.useState)(null),
      pendingSession = _useState13[0],
      setPendingSession = _useState13[1];

  var _useState14 = (0,react.useState)([]),
      ticketSummaryPanelContent = _useState14[0],
      setTicketSummaryPanelContent = _useState14[1];

  var setPriorityAllocFullSessions = (0,usePriorityAllocationStore/* usePriorityAllocationStore */.q)(function (state) {
    return state.setPriorityAllocFullSessions;
  });
  var updatePriorityAllocFullSession = (0,usePriorityAllocationStore/* usePriorityAllocationStore */.q)(function (state) {
    return state.updatePriorityAllocFullSession;
  });

  var _useModal = (0,ModalContext/* useModal */.dd)(),
      openModal = _useModal.openModal,
      closeModal = _useModal.closeModal,
      modalState = _useModal.modalState;

  var isSessionPriorityActiveAndNotFull = (0,usePriorityAllocationStore/* usePriorityAllocationStore */.q)(function (state) {
    return state.isSessionPriorityActiveAndNotFull;
  });
  (0,react.useEffect)(function () {
    sessionStorage.removeItem("formValues");
    sessionStorage.removeItem("ticketNumber");
  }, []);

  var _useQuery = (0,useQuery/* useQuery */.a)({
    queryKey: ["arePriorityAllocationsFull", priority, session === null || session === void 0 ? void 0 : session.id],
    queryFn: function () {
      var _queryFn = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0,AllocationsService/* arePriorityAllocationSessionsFull */.z3)(priority, session === null || session === void 0 ? void 0 : session.id);

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function queryFn() {
        return _queryFn.apply(this, arguments);
      }

      return queryFn;
    }(),
    enabled: Boolean(priority),
    staleTime: (0,dates/* minutesToMilliseconds */.J2)(0.5),
    refetchInterval: (0,dates/* minutesToMilliseconds */.J2)(0.5)
  }),
      priorityAllocQueryData = _useQuery.data,
      isSuccesspriorityAllocQuery = _useQuery.isSuccess;

  (0,react.useEffect)(function () {
    if (priorityAllocQueryData !== null && priorityAllocQueryData !== void 0 && priorityAllocQueryData.data) {
      if (session !== null && session !== void 0 && session.id) {
        var _priorityAllocQueryDa;

        updatePriorityAllocFullSession(session.id, priorityAllocQueryData.data[session.id]);

        if ((_priorityAllocQueryDa = priorityAllocQueryData.data[session === null || session === void 0 ? void 0 : session.id]) !== null && _priorityAllocQueryDa !== void 0 && _priorityAllocQueryDa.isFull && modalState === ModalContext/* Modals.None */.nK.None && !continueWithNonPriority && !resolvedIsPriority) {
          openModal(ModalContext/* Modals.PriorityTicketsFullyBooked */.nK.PriorityTicketsFullyBooked, function (viewPrioritySessions) {
            if (viewPrioritySessions) {
              window.location.reload();
            } else {
              closeModal();
              setContinueWithNonPriority(true);
            }
          });
        }
      } else {
        setPriorityAllocFullSessions(priorityAllocQueryData.data);
      }
    }
  }, [isSuccesspriorityAllocQuery, setPriorityAllocFullSessions, priorityAllocQueryData]);
  var isPriorityActive = (0,react.useMemo)(function () {
    if (!session) return false;
    return isSessionPriorityActiveAndNotFull(session.id);
  }, [session, isSessionPriorityActiveAndNotFull]);

  var selectSession = function selectSession(sessionId, continueWithNonPriority) {
    if (continueWithNonPriority) {
      setContinueWithNonPriority(true);
    }

    (0,SessionService/* readSession */.bf)(Number(sessionId), promoCode).then(function (response) {
      var newSession = response.data;
      setSession(newSession);
      setStepAndResetScroll(step + 1);
    });
  };

  var submitBookingInterest = function submitBookingInterest(bookingInterest, magicLink) {
    setSubmitting(true);
    (0,BookingInterestService/* createBookingInterest */.A6)(bookingInterest, magicLink).then(function (response) {
      var _response$data, _response$data2;

      setBookingInterestId((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.bookingInterestId);
      setNewBookingInterestStatus((_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.bookingInterestStatus);
      setSubmitting(false);

      if (response.error) {
        setBookingInterestError(true);

        if (typeof response.error === "string") {
          setErrorMessage(response.error);
        } else {
          setErrorMessage(response.error.title);
        }
      } else {
        sessionStorage.removeItem("formValues");
        sessionStorage.removeItem("ticketNumber");
        setStepAndResetScroll(step + 1);
      }
    });
  };

  var submit = function submit(relatedBookingInterestFormValues) {
    setSubmitting(true);

    (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var bookingInterest, magicLink, _fullCheck$data$sessi, fullCheck;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              bookingInterest = {
                sessionId: (session === null || session === void 0 ? void 0 : session.id) || 0,
                relatedBookingInterests: relatedBookingInterestFormValues === null || relatedBookingInterestFormValues === void 0 ? void 0 : relatedBookingInterestFormValues.map(function (ticket) {
                  ticket.accessibility = ticket.accessibility === "None" ? null : ticket.accessibility;
                  return {
                    user: ticket
                  };
                })
              };
              _context2.prev = 1;

              if (!resolvedIsPriority) {
                _context2.next = 11;
                break;
              }

              magicLink = priority;
              _context2.next = 6;
              return (0,AllocationsService/* arePriorityAllocationSessionsFull */.z3)(priority, session === null || session === void 0 ? void 0 : session.id);

            case 6:
              fullCheck = _context2.sent;

              if (!(fullCheck !== null && fullCheck !== void 0 && fullCheck.data && session !== null && session !== void 0 && session.id && (_fullCheck$data$sessi = fullCheck.data[session.id]) !== null && _fullCheck$data$sessi !== void 0 && _fullCheck$data$sessi.isFull)) {
                _context2.next = 11;
                break;
              }

              setSubmitting(false);
              openModal(ModalContext/* Modals.PriorityTicketsFullyBooked */.nK.PriorityTicketsFullyBooked, function (viewPrioritySessions) {
                if (viewPrioritySessions) {
                  window.location.reload();
                } else {
                  closeModal();
                  setContinueWithNonPriority(true);
                  setResolvedIsPriority(false);
                  submitBookingInterest(bookingInterest, undefined);
                }
              });
              return _context2.abrupt("return");

            case 11:
              submitBookingInterest(bookingInterest, magicLink);
              _context2.next = 18;
              break;

            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2["catch"](1);
              setErrorMessage("An error occurred while saving the ticket requests!");
              setBookingInterestError(true);

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 14]]);
    }))();
  };

  var getInitialTicketHolders = function getInitialTicketHolders(isPriorityAllocActive) {
    var _user$accessibility, _user$otherAccessibil, _user$accessibility2, _user$otherAccessibil2;

    var ticketHolders = [{
      user: {
        firstName: user === null || user === void 0 ? void 0 : user.firstName,
        lastName: user === null || user === void 0 ? void 0 : user.lastName,
        email: user === null || user === void 0 ? void 0 : user.email
      },
      assignedFirstName: user === null || user === void 0 ? void 0 : user.firstName,
      assignedLastName: user === null || user === void 0 ? void 0 : user.lastName,
      isLeadBooker: true,
      accessibility: (_user$accessibility = user === null || user === void 0 ? void 0 : user.accessibility) !== null && _user$accessibility !== void 0 ? _user$accessibility : '',
      otherAccessibility: (_user$otherAccessibil = user === null || user === void 0 ? void 0 : user.otherAccessibility) !== null && _user$otherAccessibil !== void 0 ? _user$otherAccessibil : '',
      hasAccessibilityRequirements: !!(user !== null && user !== void 0 && (_user$accessibility2 = user.accessibility) !== null && _user$accessibility2 !== void 0 && _user$accessibility2.trim()) && (user === null || user === void 0 ? void 0 : user.accessibility) != "None" || !!(user !== null && user !== void 0 && (_user$otherAccessibil2 = user.otherAccessibility) !== null && _user$otherAccessibil2 !== void 0 && _user$otherAccessibil2.trim()),
      id: 0,
      isPriorityTicket: isPriorityAllocActive,
      ticketIconStyle: isPriorityAllocActive ? "gold-outlined" : "dotted",
      accessibilityRequestStatus: undefined,
      userAgeAtBooking: user === null || user === void 0 ? void 0 : user.age
    }];
    return ticketHolders;
  };

  (0,react.useEffect)(function () {
    setTicketSummaryPanelContent(getInitialTicketHolders(isPriorityActive));
  }, [user, isPriorityActive]);

  var setTicketHolders = function setTicketHolders(relatedBookingInterestFormValues, isPriorityAllocActive) {
    if (ticketSummaryPanelContent) {
      var ticketHolders = ticketSummaryPanelContent.map(function (holder) {
        return BookingManager_objectSpread(BookingManager_objectSpread({}, holder), {}, {
          isPriorityTicket: isPriorityAllocActive,
          ticketIconStyle: isPriorityAllocActive ? "gold-outlined" : "dotted"
        });
      });
      relatedBookingInterestFormValues.map(function (relatedBookingInterest) {
        var _user$accessibility3, _user$otherAccessibil3, _relatedBookingIntere, _relatedBookingIntere2;

        ticketHolders.push({
          user: {
            firstName: relatedBookingInterest.firstName,
            lastName: relatedBookingInterest.lastName
          },
          assignedFirstName: relatedBookingInterest.firstName,
          assignedLastName: relatedBookingInterest.lastName,
          userAgeAtBooking: relatedBookingInterest.age,
          accessibility: (_user$accessibility3 = user === null || user === void 0 ? void 0 : user.accessibility) !== null && _user$accessibility3 !== void 0 ? _user$accessibility3 : '',
          otherAccessibility: (_user$otherAccessibil3 = user === null || user === void 0 ? void 0 : user.otherAccessibility) !== null && _user$otherAccessibil3 !== void 0 ? _user$otherAccessibil3 : '',
          hasAccessibilityRequirements: !!((_relatedBookingIntere = relatedBookingInterest.accessibility) !== null && _relatedBookingIntere !== void 0 && _relatedBookingIntere.trim()) && relatedBookingInterest.accessibility != "None" || !!((_relatedBookingIntere2 = relatedBookingInterest.otherAccessibility) !== null && _relatedBookingIntere2 !== void 0 && _relatedBookingIntere2.trim()),
          id: relatedBookingInterest.bookingInterestId,
          isPriorityTicket: isPriorityAllocActive,
          ticketIconStyle: isPriorityAllocActive ? "gold-outlined" : "dotted",
          accessibilityRequestStatus: undefined
        });
      });
      setTicketSummaryPanelContent(ticketHolders);
    }
  };

  var setStepAndResetScroll = function setStepAndResetScroll(value) {
    window.scrollTo({
      top: 0,
      left: 0
    });
    setStep(value);
  };

  var nextStep = function nextStep(isPriority) {
    var formValues = sessionStorage.getItem("formValues");
    var relatedBookingInterestFormValues = formValues ? JSON.parse(formValues) : null;

    if (step === 1) {
      setResolvedIsPriority(!!isPriority);
      setTicketHolders(relatedBookingInterestFormValues, isPriority);
    }

    if (step === 2) {
      submit(relatedBookingInterestFormValues);
    } else {
      setStepAndResetScroll(step + 1);
    }
  };

  var prevStep = function prevStep() {
    if (step == 2 || step == 1) {
      setTicketSummaryPanelContent(getInitialTicketHolders(isPriorityActive));
    }

    setStepAndResetScroll(step - 1);
    setBookingInterestError(false);
    setErrorMessage("");
  };

  var handleRegisterSuccess = function handleRegisterSuccess(email, firstName, selectedSession) {
    setRegistrationEmail(email);
    setRegistrationFirstName(firstName);
    setPendingSession(selectedSession);
    setRegistrationMode(true);
  };

  var handleRegistrationComplete = function handleRegistrationComplete() {
    setRegistrationMode(false);

    if (pendingSession !== null && pendingSession !== void 0 && pendingSession.id) {
      selectSession(pendingSession.id);
    }
  };

  var minAge = (session === null || session === void 0 ? void 0 : session.overrideMinimumAgeRequirement) || (show === null || show === void 0 ? void 0 : show.defaultMinimumAgeRequirement);

  if (registrationMode && pendingSession) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledEngineProvider/* default */.Z, {
      injectFirst: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Registration_BookingRegistrationFlow, {
        email: registrationEmail,
        firstName: registrationFirstName,
        selectedSession: pendingSession,
        showName: show === null || show === void 0 ? void 0 : show.name,
        showMinimumAge: show === null || show === void 0 ? void 0 : show.defaultMinimumAgeRequirement,
        onRegistrationComplete: handleRegistrationComplete,
        onBackToSessionSelection: function onBackToSessionSelection() {
          return setRegistrationMode(false);
        }
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledEngineProvider/* default */.Z, {
    injectFirst: true,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* NavigationBar */.vx, {
      showHomeIconOnMobile: step !== 0 && step !== 3,
      showMenu: step === 0,
      children: step !== 0 && step !== 3 && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Stepper */.vF, {
        stepLabels: ['Session', 'Tickets', 'Terms'],
        activeStepIndex: step
      })
    }), step === 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Session_SessionStep, {
      user: user,
      promoCode: promoCode,
      show: show,
      onNextButtonClick: selectSession,
      onRegisterSuccess: handleRegisterSuccess
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormPage, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [(step === 1 || step === 2) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [step === 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(Tickets_TicketsStep, {
            showId: show === null || show === void 0 ? void 0 : show.id,
            onNextButtonClick: nextStep,
            onPrevButtonClick: prevStep,
            user: user,
            minAge: Number(minAge),
            isPriorityActive: isPriorityActive,
            sessionId: session === null || session === void 0 ? void 0 : session.id,
            isLastMinPhase: (0,sessionUtils/* isSessionInLastMinPhase */.W)(session)
          }), step === 2 && /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_TermsStep, {
            submitting: submitting,
            show: show,
            session: session,
            onNextButtonClick: nextStep,
            onPrevButtonClick: prevStep,
            errorMessage: errorMessage,
            bookingInterestError: bookingInterestError
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* TicketSummaryPanel */.cY, {
            showName: show === null || show === void 0 ? void 0 : show.name,
            session: session,
            ticketHolders: ticketSummaryPanelContent,
            showMinimumAge: minAge
          })]
        }), step === 3 && (newBookingInterestStatus === "InvitedToTicket" || newBookingInterestStatus === "AttendanceSMSReminderSent" ? resolvedIsPriority ? /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessInvitedToPriorityTicket, {
          firstName: user === null || user === void 0 ? void 0 : user.firstName,
          bookingInterestId: bookingInterestId,
          ticketHolders: ticketSummaryPanelContent,
          session: session,
          showName: show === null || show === void 0 ? void 0 : show.name
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessInvitedToTicket, {
          firstName: user === null || user === void 0 ? void 0 : user.firstName,
          bookingInterestId: bookingInterestId,
          variant: newBookingInterestStatus === "AttendanceSMSReminderSent" ? "lastMinOffer" : "emailOffer"
        }) : resolvedIsPriority ? /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessPriority_SuccessPriority, {
          firstName: user === null || user === void 0 ? void 0 : user.firstName,
          bookingInterestId: bookingInterestId,
          accessibilityPending: newBookingInterestStatus === "InterestRegistered"
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Success_Success, {
          firstName: user === null || user === void 0 ? void 0 : user.firstName,
          bookingInterestId: bookingInterestId,
          variant: newBookingInterestStatus === "JoinedLastMinQueue" ? "lastMin" : "standard"
        }))]
      })
    })]
  });
};

/* harmony default export */ var BookingManager_BookingManager = ((0,next_router.withRouter)(BookingManager));
// EXTERNAL MODULE: ./src/contexts/CustomThemeProvider.tsx + 2 modules
var CustomThemeProvider = __webpack_require__(75044);
;// CONCATENATED MODULE: ./pages/audience/[showUrl]/index.tsx











var ShowDetailsPage = function ShowDetailsPage() {
  var router = (0,next_router.useRouter)();
  var showUrl = router.query.showUrl;

  var _useState = (0,react.useState)(),
      show = _useState[0],
      setShow = _useState[1];

  var promoCode = router.query.promoCode;
  var priority = router.query.priority;

  var _useColorModeContext = (0,CustomThemeProvider/* useColorModeContext */.XE)(),
      setColorMode = _useColorModeContext.setColorMode;

  setColorMode("dark");
  (0,react.useEffect)(function () {
    window.localStorage.removeItem("redirectURL");

    if (showUrl) {
      (0,ShowService/* readShow */.tj)(showUrl.toString()).then(function (response) {
        setShow(response.data);
      });
    }
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "".concat(show === null || show === void 0 ? void 0 : show.name, " | That's The Ticket")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: show === null || show === void 0 ? void 0 : show.name
      }, "ogTitle"), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:title",
        content: show === null || show === void 0 ? void 0 : show.name
      }, "twitterTitle")]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BookingManager_BookingManager, {
      show: show,
      promoCode: promoCode,
      priority: priority
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
};

var __N_SSP = true;
/* harmony default export */ var _showUrl_ = ((0,next_router.withRouter)(ShowDetailsPage));

/***/ }),

/***/ 96204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Page_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68491);
/* harmony import */ var _Page_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Page_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var Page = function Page(props) {
  var className = props.className,
      children = props.children;
  var classes = classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Page_module_scss__WEBPACK_IMPORTED_MODULE_3___default().page), (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, className, className));
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    className: classes,
    children: children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Page);

/***/ }),

/***/ 23604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o6": function() { return /* binding */ AllocationTypeEnum; },
/* harmony export */   "qK": function() { return /* binding */ OperationStatusEnum; },
/* harmony export */   "qY": function() { return /* binding */ ManagerPermissionEnum; },
/* harmony export */   "vr": function() { return /* binding */ ReviewAndSendResponse; }
/* harmony export */ });
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82262);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92777);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10748);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81531);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63553);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37247);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59499);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53901);








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }


var OperationStatusEnum;

(function (OperationStatusEnum) {
  OperationStatusEnum[OperationStatusEnum["existedAndNoChange"] = 0] = "existedAndNoChange";
  OperationStatusEnum[OperationStatusEnum["existedAndChanged"] = 1] = "existedAndChanged";
  OperationStatusEnum[OperationStatusEnum["existedAndDeleted"] = 2] = "existedAndDeleted";
  OperationStatusEnum[OperationStatusEnum["new"] = 3] = "new";
})(OperationStatusEnum || (OperationStatusEnum = {}));

var AllocationTypeEnum;

(function (AllocationTypeEnum) {
  AllocationTypeEnum["generic"] = "Generic";
  AllocationTypeEnum["vip"] = "VIP";
  AllocationTypeEnum["friendsAndFamily"] = "FriendsAndFamily";
  AllocationTypeEnum["priority"] = "Priority";
})(AllocationTypeEnum || (AllocationTypeEnum = {}));

var ManagerPermissionEnum;

(function (ManagerPermissionEnum) {
  ManagerPermissionEnum[ManagerPermissionEnum["allocate"] = 1] = "allocate";
  ManagerPermissionEnum[ManagerPermissionEnum["view"] = 2] = "view";
  ManagerPermissionEnum[ManagerPermissionEnum["send"] = 3] = "send";
})(ManagerPermissionEnum || (ManagerPermissionEnum = {}));

var ReviewAndSendResponse = /*#__PURE__*/function (_ApiResponse) {
  (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ReviewAndSendResponse, _ApiResponse);

  var _super = _createSuper(ReviewAndSendResponse);

  function ReviewAndSendResponse(params) {
    var _params$notifiedEmail;

    var _this;

    (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, ReviewAndSendResponse);

    _this = _super.call(this, params);

    (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this), "notifiedEmails", void 0);

    _this.notifiedEmails = (_params$notifiedEmail = params.notifiedEmails) !== null && _params$notifiedEmail !== void 0 ? _params$notifiedEmail : [];
    return _this;
  }

  return (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(ReviewAndSendResponse);
}(_types__WEBPACK_IMPORTED_MODULE_2__/* .ApiResponse */ .Rf);

/***/ }),

/***/ 94826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vm": function() { return /* binding */ ListContainer; },
/* harmony export */   "_z": function() { return /* binding */ PageContainer; },
/* harmony export */   "ah": function() { return /* binding */ MaxWidthContainer; },
/* harmony export */   "iI": function() { return /* binding */ GlobalContainer; }
/* harmony export */ });
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90948);

var GlobalContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    position: "relative",
    width: "100%",
    maxWidth: "1440px",
    marginLeft: "auto",
    marginRight: "auto"
  };
});
var MaxWidthContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref2) {
  var theme = _ref2.theme;
  return {
    maxWidth: "875px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._700
  };
});
var ListContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref3) {
  var theme = _ref3.theme;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "3rem",
    alignSelf: "stretch"
  };
});
var PageContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref4) {
  var theme = _ref4.theme;
  return {
    position: "relative",
    display: "flex",
    flexDirection: "row",
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "-".concat(theme.space._1000),
    gap: theme.space._700,
    padding: "0 ".concat(theme.space._900, " ").concat(theme.space._900, " ").concat(theme.space._900),
    "@media (max-width: 992px)": {
      marginTop: "-".concat(theme.space._800),
      gap: theme.space._600,
      padding: "0 ".concat(theme.space._400, " ").concat(theme.space._400, " ").concat(theme.space._400)
    }
  };
});

/***/ }),

/***/ 72116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O7": function() { return /* binding */ myManagedShows; },
/* harmony export */   "S": function() { return /* binding */ myAllocations; },
/* harmony export */   "bu": function() { return /* binding */ deleteAllocation; },
/* harmony export */   "c": function() { return /* binding */ bulkUpdateAllocations; },
/* harmony export */   "j": function() { return /* binding */ reviewAndSend; },
/* harmony export */   "jV": function() { return /* binding */ myShows; },
/* harmony export */   "z3": function() { return /* binding */ arePriorityAllocationSessionsFull; }
/* harmony export */ });
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50029);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var src_models_AllocationReviewAndSend__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23604);
/* harmony import */ var src_models_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53901);
/* harmony import */ var src_utils_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89092);
/* harmony import */ var _AuthenticationService__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28148);






var myAllocations = /*#__PURE__*/function () {
  var _ref = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(showId) {
    var query, result, resultJson, message;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            query = showId != null ? "?showId=".concat(showId) : "";
            _context.next = 4;
            return (0,src_utils_auth__WEBPACK_IMPORTED_MODULE_3__/* .fetchWithAuth */ .ri)("/api/backend/v2/allocations/my-allocations".concat(query));

          case 4:
            result = _context.sent;

            if (!(result.status >= 400 && result.status < 600)) {
              _context.next = 7;
              break;
            }

            throw new Error("Server not returned a valid response");

          case 7:
            _context.next = 9;
            return result.json();

          case 9:
            resultJson = _context.sent;
            return _context.abrupt("return", new src_models_types__WEBPACK_IMPORTED_MODULE_2__/* .MyAllocationsResponse */ .VF({
              data: resultJson
            }));

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](0);

            if (_context.t0 instanceof Error) {
              message = _context.t0.message;
            } else {
              message = "Unable to load my allocations";
            }

            return _context.abrupt("return", new src_models_types__WEBPACK_IMPORTED_MODULE_2__/* .MyAllocationsResponse */ .VF({
              error: message
            }));

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 13]]);
  }));

  return function myAllocations(_x) {
    return _ref.apply(this, arguments);
  };
}();
var bulkUpdateAllocations = /*#__PURE__*/function () {
  var _ref2 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(bulkUpdateAllocationCommand) {
    var _resJson$notifiedEmai, body, res, resJson, errorMessage, message;

    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            body = JSON.stringify(bulkUpdateAllocationCommand);
            _context2.next = 4;
            return (0,src_utils_auth__WEBPACK_IMPORTED_MODULE_3__/* .fetchWithAuth */ .ri)("/api/backend/v2/allocations/bulk-update", {
              method: "PATCH",
              headers: {
                "Content-Type": "application/json"
              },
              body: body
            });

          case 4:
            res = _context2.sent;
            _context2.next = 7;
            return res.json();

          case 7:
            resJson = _context2.sent;

            if (!(res.status >= 400)) {
              _context2.next = 13;
              break;
            }

            if (!(resJson && resJson.errors && Array.isArray(resJson.errors.message) && resJson.errors.message.length > 0)) {
              _context2.next = 12;
              break;
            }

            errorMessage = resJson.errors.message.join(", ");
            throw new Error(errorMessage);

          case 12:
            throw new Error("Server did not return a valid response");

          case 13:
            _context2.next = 15;
            return (0,_AuthenticationService__WEBPACK_IMPORTED_MODULE_4__/* .refreshAllocationRights */ .oB)();

          case 15:
            return _context2.abrupt("return", {
              data: new src_models_types__WEBPACK_IMPORTED_MODULE_2__/* .UpdateAllocationResponse */ .UI({
                data: resJson
              }),
              notifiedEmails: (_resJson$notifiedEmai = resJson.notifiedEmails) !== null && _resJson$notifiedEmai !== void 0 ? _resJson$notifiedEmai : []
            });

          case 18:
            _context2.prev = 18;
            _context2.t0 = _context2["catch"](0);

            if (_context2.t0 instanceof Error) {
              message = _context2.t0.message;
            } else {
              message = "Unable to update allocations";
            }

            throw new Error(message);

          case 22:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 18]]);
  }));

  return function bulkUpdateAllocations(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var myShows = /*#__PURE__*/function () {
  var _ref3 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3() {
    var result, resultJson, message;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return (0,src_utils_auth__WEBPACK_IMPORTED_MODULE_3__/* .fetchWithAuth */ .ri)("/api/backend/v2/shows/my-shows");

          case 3:
            result = _context3.sent;

            if (!(result.status >= 400 && result.status < 600)) {
              _context3.next = 6;
              break;
            }

            throw new Error("Server not returned a valid response");

          case 6:
            _context3.next = 8;
            return result.json();

          case 8:
            resultJson = _context3.sent;
            return _context3.abrupt("return", new src_models_types__WEBPACK_IMPORTED_MODULE_2__/* .MyAllocationsResponse */ .VF({
              data: resultJson
            }));

          case 12:
            _context3.prev = 12;
            _context3.t0 = _context3["catch"](0);

            if (_context3.t0 instanceof Error) {
              message = _context3.t0.message;
            } else {
              message = "Unable to load my allocations";
            }

            return _context3.abrupt("return", new src_models_types__WEBPACK_IMPORTED_MODULE_2__/* .MyAllocationsResponse */ .VF({
              error: message
            }));

          case 16:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 12]]);
  }));

  return function myShows() {
    return _ref3.apply(this, arguments);
  };
}();
var myManagedShows = /*#__PURE__*/function () {
  var _ref4 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4() {
    var result, resultJson, message;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return (0,src_utils_auth__WEBPACK_IMPORTED_MODULE_3__/* .fetchWithAuth */ .ri)("/api/backend/v2/shows/my-managed-shows");

          case 3:
            result = _context4.sent;

            if (!(result.status >= 400 && result.status < 600)) {
              _context4.next = 6;
              break;
            }

            throw new Error("Server not returned a valid response");

          case 6:
            _context4.next = 8;
            return result.json();

          case 8:
            resultJson = _context4.sent;
            return _context4.abrupt("return", new src_models_types__WEBPACK_IMPORTED_MODULE_2__/* .MyAllocationsResponse */ .VF({
              data: resultJson
            }));

          case 12:
            _context4.prev = 12;
            _context4.t0 = _context4["catch"](0);

            if (_context4.t0 instanceof Error) {
              message = _context4.t0.message;
            } else {
              message = "Unable to load my managed shows";
            }

            return _context4.abrupt("return", new src_models_types__WEBPACK_IMPORTED_MODULE_2__/* .MyAllocationsResponse */ .VF({
              error: message
            }));

          case 16:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 12]]);
  }));

  return function myManagedShows() {
    return _ref4.apply(this, arguments);
  };
}();
var reviewAndSend = /*#__PURE__*/function () {
  var _ref5 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5(payload) {
    var _resultText$allocatio, _resultText$notifiedE, body, result, resultText, message;

    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            body = JSON.stringify(payload);
            _context5.next = 4;
            return (0,src_utils_auth__WEBPACK_IMPORTED_MODULE_3__/* .fetchWithAuth */ .ri)("/api/backend/v2/allocations/bulk-upsert", {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: body
            });

          case 4:
            result = _context5.sent;
            _context5.next = 7;
            return result.json();

          case 7:
            resultText = _context5.sent;

            if (!(result.status === 401)) {
              _context5.next = 10;
              break;
            }

            return _context5.abrupt("return", new src_models_AllocationReviewAndSend__WEBPACK_IMPORTED_MODULE_1__/* .ReviewAndSendResponse */ .vr({
              data: [],
              error: "You are unauthorized to create or update allocations."
            }));

          case 10:
            if (!(result.status >= 400 && result.status < 600)) {
              _context5.next = 12;
              break;
            }

            return _context5.abrupt("return", new src_models_AllocationReviewAndSend__WEBPACK_IMPORTED_MODULE_1__/* .ReviewAndSendResponse */ .vr({
              data: [],
              error: resultText
            }));

          case 12:
            _context5.next = 14;
            return (0,_AuthenticationService__WEBPACK_IMPORTED_MODULE_4__/* .refreshAllocationRights */ .oB)();

          case 14:
            return _context5.abrupt("return", new src_models_AllocationReviewAndSend__WEBPACK_IMPORTED_MODULE_1__/* .ReviewAndSendResponse */ .vr({
              data: (_resultText$allocatio = resultText.allocations) !== null && _resultText$allocatio !== void 0 ? _resultText$allocatio : resultText,
              notifiedEmails: (_resultText$notifiedE = resultText.notifiedEmails) !== null && _resultText$notifiedE !== void 0 ? _resultText$notifiedE : []
            }));

          case 17:
            _context5.prev = 17;
            _context5.t0 = _context5["catch"](0);
            console.error(_context5.t0);
            message = "Unable to create and/or update allocations.";
            return _context5.abrupt("return", new src_models_AllocationReviewAndSend__WEBPACK_IMPORTED_MODULE_1__/* .ReviewAndSendResponse */ .vr({
              data: [],
              error: message
            }));

          case 22:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 17]]);
  }));

  return function reviewAndSend(_x3) {
    return _ref5.apply(this, arguments);
  };
}();
var arePriorityAllocationSessionsFull = /*#__PURE__*/function () {
  var _ref6 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6(allocationSessionIdOrMagicLink, sessionId) {
    var url, result, resultJson;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            url = "/api/backend/v2/allocations/".concat(allocationSessionIdOrMagicLink, "/are-priority-allocation-sessions-full").concat(sessionId ? "?sessionId=" + sessionId : "");
            _context6.next = 4;
            return (0,src_utils_auth__WEBPACK_IMPORTED_MODULE_3__/* .defaultFetch */ .zo)(url);

          case 4:
            result = _context6.sent;

            if (!(result.status >= 400 && result.status < 600)) {
              _context6.next = 7;
              break;
            }

            throw new Error("Server not returned a valid response");

          case 7:
            _context6.next = 9;
            return result.json();

          case 9:
            resultJson = _context6.sent;
            return _context6.abrupt("return", new src_models_types__WEBPACK_IMPORTED_MODULE_2__/* .IsPriorityAllocationFullResponse */ .pt({
              data: resultJson
            }));

          case 13:
            _context6.prev = 13;
            _context6.t0 = _context6["catch"](0);
            console.error(_context6.t0);
            return _context6.abrupt("return", new src_models_types__WEBPACK_IMPORTED_MODULE_2__/* .IsPriorityAllocationFullResponse */ .pt({
              error: "Unable to determin if session is full."
            }));

          case 17:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 13]]);
  }));

  return function arePriorityAllocationSessionsFull(_x4, _x5) {
    return _ref6.apply(this, arguments);
  };
}();
var deleteAllocation = /*#__PURE__*/function () {
  var _ref7 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee7(allocationId) {
    var result, resText;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return (0,src_utils_auth__WEBPACK_IMPORTED_MODULE_3__/* .fetchWithAuth */ .ri)("/api/backend/v2/allocations/".concat(allocationId), {
              method: 'DELETE'
            });

          case 2:
            result = _context7.sent;

            if (!(result.status === 200)) {
              _context7.next = 7;
              break;
            }

            return _context7.abrupt("return", true);

          case 7:
            if (!(result.status === 401)) {
              _context7.next = 11;
              break;
            }

            throw new Error("You are not authorized to delete this allocation.");

          case 11:
            if (!(result.status === 404)) {
              _context7.next = 15;
              break;
            }

            throw new Error("The allocation does not exist.");

          case 15:
            _context7.next = 17;
            return result.text();

          case 17:
            resText = _context7.sent;
            console.warn(resText);
            throw new Error("Server returned a non-successful response");

          case 20:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function deleteAllocation(_x6) {
    return _ref7.apply(this, arguments);
  };
}();

/***/ }),

/***/ 82969:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/audience/[showUrl]",
      function () {
        return __webpack_require__(7084);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 68491:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page__LFdNN"};

/***/ }),

/***/ 90863:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bookingInterestErrorDialog":"BookingInterestErrorDialog_bookingInterestErrorDialog__Kv_nT","title":"BookingInterestErrorDialog_title__NTvnO","cancelButton":"BookingInterestErrorDialog_cancelButton__yCi2B"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7504,9765,961,1681,6470,9774,2888,179], function() { return __webpack_exec__(82969); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);